//MOCK DATA FOR TESTING PURPOSES

import dayjs from 'dayjs';
import { DeliveryBoardItem } from 'views/delivery-board/types/delivery-board-model.type';
import { DistributionStatus } from 'views/delivery-board/types/distribution-status.enum';
import { OrderShipmentStatus } from 'views/delivery-board/types/order-shipment-status.enum';

export const DeliveryBoardItems: DeliveryBoardItem[] = [
  {
    siteName: 'FURNESET',
    siteErpId: '2800008248',
    globalSiteId: 'e79bbb46-7eea-4b3e-b864-867634a7b908',
    siteLocation: {
      latitude: 62.6461,
      longitude: 7.101183,
    },
    distributionStatus: DistributionStatus.NOT_STARTED,
    vessel: 'Terneskjær',
    vesselLocation: {
      latitude: 59.19812666666667,
      longitude: 5.797698333333333,
    },
    etaAtShipmentStart: '2024-07-28T22:44:32+00:00',
    currentEta: '2024-07-29T00:10:30+00:00',
    orderNumber: '1001222914',
    orderItems: [
      {
        itemName: 'HARMONY 250 0.2PF NP750',
        quantity: 20250.0,
        lineNumber: 10,
        itemNumber: '000000000130040475',
      },
    ],
    distributionId: '0081d3cb-bc5b-4226-8306-93c128d6da18',
    status: OrderShipmentStatus.ON_ROUTE,
    dispatchDate: '2024-07-27T00:00:00+00:00',
    plantName: 'Gangstøvika',
    plantId: '2IRP',
    initialEta: dayjs().add(1, 'hour').toISOString(),
    arrivalTime: '',
  },
  {
    siteName: 'MOLLVIKA',
    siteErpId: '2800008257',
    globalSiteId: '8764287b-6d5d-400f-a51d-376b18aa7d79',
    siteLocation: {
      latitude: 68.936583,
      longitude: 16.723383,
    },
    distributionStatus: DistributionStatus.NOT_STARTED,
    vessel: 'Eidsvaag Opal',
    vesselLocation: {
      latitude: 69.78573166666666,
      longitude: 18.307843333333334,
    },
    etaAtShipmentStart: '',
    currentEta: '2024-07-31T08:33:18+00:00',
    orderNumber: '1001278206',
    orderItems: [
      {
        itemName: 'RAPID 80 ADAPT 40A BLK',
        quantity: 12500.0,
        lineNumber: 20,
        itemNumber: '000000000107552893',
      },
      {
        itemName: 'RAPID MAX HP 500 50A 500',
        quantity: 8500.0,
        lineNumber: 40,
        itemNumber: '000000000107550941',
      },
      {
        itemName: 'RAPID MAX HP 200 40A BLK',
        quantity: 23500.0,
        lineNumber: 10,
        itemNumber: '000000000107553040',
      },
    ],
    distributionId: '04254151-4fd3-4157-845a-a515198d8556',
    status: OrderShipmentStatus.LOADING,
    dispatchDate: '2024-07-29T00:00:00+00:00',
    plantName: 'Bergneset',
    plantId: '1FBT',
    initialEta: dayjs().add(4, 'days').toISOString(),
    arrivalTime: '',
  },
  {
    siteName: 'GJERDE',
    siteErpId: '2800008261',
    globalSiteId: '109dbb35-cbdc-4f93-8bda-f0790fc8f82c',
    siteLocation: {
      latitude: 63.299667,
      longitude: 8.4183,
    },
    distributionStatus: DistributionStatus.FINISHED,
    vessel: 'Aqua Fjell',
    vesselLocation: {
      latitude: 64.85982666666666,
      longitude: 11.238265,
    },
    etaAtShipmentStart: '2024-07-25T04:55:11+00:00',
    currentEta: '2024-07-26T01:36:52+00:00',
    orderNumber: '1001249558',
    orderItems: [
      {
        itemName: 'HARMONY 500 0.2PF NP750',
        quantity: 60000.0,
        lineNumber: 10,
        itemNumber: '000000000130040452',
      },
    ],
    distributionId: '0467ef49-dc2d-497f-9804-afd249cd0130',
    status: OrderShipmentStatus.DELIVERED,
    dispatchDate: '2024-07-25T00:00:00+00:00',
    plantName: 'Kristiansund',
    plantId: '2IRO',
    initialEta: dayjs().add(4, 'days').toISOString(),
    arrivalTime: '2024-07-25T07:25:28+00:00',
    documentIds: ['7df43f90-9978-41a4-a1d8-2ae2fa5f3a0b', '26f043f1-66c1-4618-8df0-0b654e573a61'],
  },
  {
    siteName: 'DRYNA',
    siteErpId: '2800007943',
    globalSiteId: '4b3ae69a-39cb-4fcb-b6fd-b4b7f00fb451',
    siteLocation: {
      latitude: 62.6444,
      longitude: 6.5568,
    },
    distributionStatus: DistributionStatus.NOT_STARTED,
    vessel: 'Terneskjær',
    vesselLocation: {
      latitude: 59.19812666666667,
      longitude: 5.797698333333333,
    },
    etaAtShipmentStart: '',
    currentEta: '2024-08-04T09:09:15+00:00',
    orderNumber: '1001271024',
    orderItems: [
      {
        itemName: 'ST102 1000 50A 500',
        quantity: 130000.0,
        lineNumber: 10,
        itemNumber: '000000000130090078',
      },
    ],
    distributionId: '04c6714a-13dd-4283-a05a-c93b0eb52439',
    status: OrderShipmentStatus.LOADING,
    dispatchDate: '2024-08-03T00:00:00+00:00',
    plantName: 'Gangstøvika',
    plantId: '2IRP',
    initialEta: dayjs().add(4, 'days').toISOString(),
    arrivalTime: '',
  },
  {
    siteName: 'BJØRGA',
    siteErpId: '2000075686',
    globalSiteId: '45512f17-7c3c-45a7-9a7d-2281a512bb3e',
    siteLocation: {
      latitude: 69.153983,
      longitude: 17.948417,
    },
    distributionStatus: DistributionStatus.NOT_STARTED,
    vessel: 'Eidsvaag Opal',
    vesselLocation: {
      latitude: 69.78573166666666,
      longitude: 18.307843333333334,
    },
    etaAtShipmentStart: '',
    currentEta: '2024-07-30T03:22:07+00:00',
    orderNumber: '1001278205',
    orderItems: [
      {
        itemName: 'RAPID MAX HP 200 40A 500',
        quantity: 21000.0,
        lineNumber: 40,
        itemNumber: '000000000107551872',
      },
      {
        itemName: 'RAPID MAX HP 500 50A 500',
        quantity: 15000.0,
        lineNumber: 30,
        itemNumber: '000000000107550941',
      },
    ],
    distributionId: '055795b3-15be-4a2c-a633-e4e422722269',
    status: OrderShipmentStatus.LOADING,
    dispatchDate: '2024-07-29T00:00:00+00:00',
    plantName: 'Bergneset',
    plantId: '1FBT',
    initialEta: dayjs().add(4, 'days').toISOString(),
    arrivalTime: '',
  },
  {
    siteName: 'BØRFJORD',
    siteErpId: '2000077132',
    globalSiteId: '57795338-414b-453f-92de-8f0ff45f77a2',
    siteLocation: {
      latitude: 70.645333,
      longitude: 22.694317,
    },
    distributionStatus: DistributionStatus.FINISHED,
    vessel: 'With Frohavet',
    vesselLocation: {
      latitude: 70.76188666666667,
      longitude: 24.221655,
    },
    etaAtShipmentStart: '2024-07-25T19:00:08+00:00',
    currentEta: '2024-07-25T18:46:51+00:00',
    orderNumber: '1001267689',
    orderItems: [
      {
        itemName: 'ST102 1000 50A 500',
        quantity: 60000.0,
        lineNumber: 20,
        itemNumber: '000000000130090078',
      },
    ],
    distributionId: '09261b8d-375c-4486-8308-aa3e5e26666c',
    status: OrderShipmentStatus.DELIVERED,
    dispatchDate: '2024-07-24T00:00:00+00:00',
    plantName: 'Bergneset',
    plantId: '1FBT',
    initialEta: dayjs().add(4, 'days').toISOString(),
    arrivalTime: '2024-07-25T19:11:58+00:00',
    documentIds: ['7df43f90-9978-41a4-a1d8-2ae2fa5f3a0b', '26f043f1-66c1-4618-8df0-0b654e573a61'],
  },
  {
    siteName: 'TRÆLVIKA',
    siteErpId: '2000069806',
    globalSiteId: 'db3126e6-2667-4bf3-9411-8c57ca5d4d6a',
    siteLocation: {
      latitude: 69.518467,
      longitude: 17.68705,
    },
    distributionStatus: DistributionStatus.FINISHED,
    vessel: 'Eidsvaag Opal',
    vesselLocation: {
      latitude: 69.23821666666666,
      longitude: 19.358983333333335,
    },
    etaAtShipmentStart: '2024-07-24T20:38:26+00:00',
    currentEta: '2024-07-24T15:31:47+00:00',
    orderNumber: '1001266375',
    orderItems: [
      {
        itemName: 'RAPID MAX HP 200 40A 500',
        quantity: 95500.0,
        lineNumber: 20,
        itemNumber: '000000000107551872',
      },
    ],
    distributionId: '0e66f43e-de74-4720-8e86-47227751d6e3',
    status: OrderShipmentStatus.DELIVERED,
    dispatchDate: '2024-07-22T00:00:00+00:00',
    plantName: 'Bergneset',
    plantId: '1FBT',
    initialEta: dayjs().add(4, 'days').toISOString(),
    arrivalTime: '2024-07-24T15:15:45+00:00',
  },
  {
    siteName: 'DRYNA',
    siteErpId: '2800007943',
    globalSiteId: '4b3ae69a-39cb-4fcb-b6fd-b4b7f00fb451',
    siteLocation: {
      latitude: 62.6444,
      longitude: 6.5568,
    },
    distributionStatus: DistributionStatus.NOT_STARTED,
    vessel: 'Terneskjær',
    vesselLocation: {
      latitude: 59.19812666666667,
      longitude: 5.797698333333333,
    },
    etaAtShipmentStart: '2024-07-28T14:06:46+00:00',
    currentEta: '2024-07-28T15:32:44+00:00',
    orderNumber: '1001247533',
    orderItems: [
      {
        itemName: 'HARMONY 2500 0.175PF NP750',
        quantity: 94500.0,
        lineNumber: 20,
        itemNumber: '000000000130040424',
      },
      {
        itemName: 'RAPID HP 1000 HQ 50A 500',
        quantity: 120000.0,
        lineNumber: 30,
        itemNumber: '000000000107553222',
      },
    ],
    distributionId: '0fb5ef23-d6b4-4eac-99dc-6d5e5be62e62',
    status: OrderShipmentStatus.ON_ROUTE,
    dispatchDate: '2024-07-27T00:00:00+00:00',
    plantName: 'Gangstøvika',
    plantId: '2IRP',
    initialEta: dayjs().add(4, 'days').toISOString(),
    arrivalTime: '',
  },
  {
    siteName: 'KLOKKSTEIN',
    siteErpId: '2000066942',
    globalSiteId: 'f16d2218-9bc1-4162-a3fc-220fbd2a4fca',
    siteLocation: {
      latitude: 69.816117,
      longitude: 20.717817,
    },
    distributionStatus: DistributionStatus.NOT_STARTED,
    vessel: 'Eidsvaag Opal',
    vesselLocation: {
      latitude: 69.78573166666666,
      longitude: 18.307843333333334,
    },
    etaAtShipmentStart: '',
    currentEta: '2024-08-03T15:05:20+00:00',
    orderNumber: '1001282218',
    orderItems: [
      {
        itemName: 'ST102 1000 50A BLK',
        quantity: 173000.0,
        lineNumber: 10,
        itemNumber: '000000000130090079',
      },
    ],
    distributionId: '10215340-1465-4a56-82df-b66466b95fdd',
    status: OrderShipmentStatus.LOADING,
    dispatchDate: '2024-08-01T00:00:00+00:00',
    plantName: 'Bergneset',
    plantId: '1FBT',
    initialEta: dayjs().add(4, 'days').toISOString(),
    arrivalTime: '',
  },
  {
    siteName: 'BARØYA',
    siteErpId: '2000065770',
    globalSiteId: 'f878e8be-b002-4801-9a1c-8f45560dea06',
    siteLocation: {
      latitude: 64.621117,
      longitude: 11.235517,
    },
    distributionStatus: DistributionStatus.NOT_STARTED,
    vessel: 'Orion Olympus',
    vesselLocation: {
      latitude: 64.94696166666667,
      longitude: 11.457813333333332,
    },
    etaAtShipmentStart: '',
    currentEta: '2024-07-30T14:26:11+00:00',
    orderNumber: '1001251940',
    orderItems: [
      {
        itemName: 'ST102 1000 50A BLK',
        quantity: 40000.0,
        lineNumber: 10,
        itemNumber: '000000000130090079',
      },
    ],
    distributionId: '10a0260d-330c-4269-b27d-39b877daf2b0',
    status: OrderShipmentStatus.LOADING,
    dispatchDate: '2024-07-28T00:00:00+00:00',
    plantName: 'Florø',
    plantId: '1FBS',
    initialEta: dayjs().add(4, 'days').toISOString(),
    arrivalTime: '',
  },
  {
    siteName: 'FARMANNSØYA',
    siteErpId: '2800008242',
    globalSiteId: '13379072-a2ce-4330-968e-b56b0c75b347',
    siteLocation: {
      latitude: 64.184517,
      longitude: 10.1222,
    },
    distributionStatus: DistributionStatus.NOT_STARTED,
    vessel: 'Orion Olympus',
    vesselLocation: {
      latitude: 64.94696166666667,
      longitude: 11.457813333333332,
    },
    etaAtShipmentStart: '2024-07-26T15:42:41+00:00',
    currentEta: '2024-07-26T15:58:08+00:00',
    orderNumber: '1001207390',
    orderItems: [
      {
        itemName: 'ST102 1000 FLOW 50A 500',
        quantity: 120000.0,
        lineNumber: 20,
        itemNumber: '000000000130091475',
      },
    ],
    distributionId: '10bd8b19-ef29-4f50-a598-5950f2e8294b',
    status: OrderShipmentStatus.ON_ROUTE,
    dispatchDate: '2024-07-25T00:00:00+00:00',
    plantName: 'Halsa',
    plantId: '1FBU',
    initialEta: dayjs().add(4, 'days').toISOString(),
    arrivalTime: '',
  },
  {
    siteName: 'RATAREN',
    siteErpId: '2800007588',
    globalSiteId: '25dfa0fb-21a8-43e9-9ce0-a6157d889473',
    siteLocation: {
      latitude: 63.780583,
      longitude: 8.5176,
    },
    distributionStatus: DistributionStatus.NOT_STARTED,
    vessel: 'Aqua Fjell',
    vesselLocation: {
      latitude: 64.85982666666666,
      longitude: 11.238265,
    },
    etaAtShipmentStart: '',
    currentEta: '2024-08-01T19:02:47+00:00',
    orderNumber: '1001220777',
    orderItems: [
      {
        itemName: 'RAPID HP 1000 HQ 50A 500',
        quantity: 175000.0,
        lineNumber: 20,
        itemNumber: '000000000107553222',
      },
      {
        itemName: 'ST102 1000 50A 500',
        quantity: 25000.0,
        lineNumber: 50,
        itemNumber: '000000000130090078',
      },
    ],
    distributionId: '12114e4a-8b07-4c04-9436-29a7fbc145ec',
    status: OrderShipmentStatus.LOADING,
    dispatchDate: '2024-08-01T00:00:00+00:00',
    plantName: 'Gangstøvika',
    plantId: '2IRP',
    initialEta: dayjs().add(4, 'days').toISOString(),
    arrivalTime: '',
  },
  {
    siteName: 'KLOKKSTEIN',
    siteErpId: '2000066942',
    globalSiteId: 'f16d2218-9bc1-4162-a3fc-220fbd2a4fca',
    siteLocation: {
      latitude: 69.816117,
      longitude: 20.717817,
    },
    distributionStatus: DistributionStatus.NOT_STARTED,
    vessel: 'Eidsvaag Opal',
    vesselLocation: {
      latitude: 69.78573166666666,
      longitude: 18.307843333333334,
    },
    etaAtShipmentStart: '2024-07-27T16:42:17+00:00',
    currentEta: '2024-07-27T16:27:52+00:00',
    orderNumber: '1001270109',
    orderItems: [
      {
        itemName: 'ST102 1000 50A BLK',
        quantity: 270000.0,
        lineNumber: 10,
        itemNumber: '000000000130090079',
      },
    ],
    distributionId: '145bea52-3e9c-49d6-b2c2-f2d0dccc4dde',
    status: OrderShipmentStatus.ON_ROUTE,
    dispatchDate: '2024-07-25T00:00:00+00:00',
    plantName: 'Bergneset',
    plantId: '1FBT',
    initialEta: dayjs().add(4, 'days').toISOString(),
    arrivalTime: '',
  },
  {
    siteName: 'LEKANGSUND II',
    siteErpId: '2800007563',
    globalSiteId: 'e539cdb7-0912-4235-8031-cb35d59de1e2',
    siteLocation: {
      latitude: 69.037683,
      longitude: 17.264133,
    },
    distributionStatus: DistributionStatus.NOT_STARTED,
    vessel: 'Eidsvaag Opal',
    vesselLocation: {
      latitude: 69.78573166666666,
      longitude: 18.307843333333334,
    },
    etaAtShipmentStart: '',
    currentEta: '2024-07-30T10:04:59+00:00',
    orderNumber: '1001278208',
    orderItems: [
      {
        itemName: 'ST102 1000 50A BLK',
        quantity: 101500.0,
        lineNumber: 10,
        itemNumber: '000000000130090079',
      },
      {
        itemName: 'RAPID HP 1000 HQ 50A BLK',
        quantity: 128000.0,
        lineNumber: 20,
        itemNumber: '000000000107551259',
      },
    ],
    distributionId: '1479b226-e208-485b-acba-0cc0da1be1b8',
    status: OrderShipmentStatus.LOADING,
    dispatchDate: '2024-07-29T00:00:00+00:00',
    plantName: 'Bergneset',
    plantId: '1FBT',
    initialEta: dayjs().add(4, 'days').toISOString(),
    arrivalTime: '',
  },
  {
    siteName: 'KVITHOLMEN',
    siteErpId: '2000056592',
    globalSiteId: '6908d54c-85f5-4726-8320-f20ae2b0950e',
    siteLocation: {
      latitude: 63.28102,
      longitude: 8.0932,
    },
    distributionStatus: DistributionStatus.NOT_STARTED,
    vessel: 'Orion Olympus',
    vesselLocation: {
      latitude: 64.94696166666667,
      longitude: 11.457813333333332,
    },
    etaAtShipmentStart: '',
    currentEta: '2024-08-04T09:30:20+00:00',
    orderNumber: '1001270194',
    orderItems: [
      {
        itemName: 'RAPID MAX HP 200 40A 500',
        quantity: 40000.0,
        lineNumber: 10,
        itemNumber: '000000000107551872',
      },
    ],
    distributionId: '1bf5a522-c65e-417a-a5aa-9920622b4b5c',
    status: OrderShipmentStatus.LOADING,
    dispatchDate: '2024-08-01T00:00:00+00:00',
    plantName: 'Halsa',
    plantId: '1FBU',
    initialEta: dayjs().add(4, 'days').toISOString(),
    arrivalTime: '',
  },
  {
    siteName: 'KORSNES',
    siteErpId: '2000070763',
    globalSiteId: '58b93357-f233-412f-9b8b-361c103d4224',
    siteLocation: {
      latitude: 69.986917,
      longitude: 19.931633,
    },
    distributionStatus: DistributionStatus.FINISHED,
    vessel: 'Eidsvaag Opal',
    vesselLocation: {
      latitude: 69.78573166666666,
      longitude: 18.307843333333334,
    },
    etaAtShipmentStart: '2024-07-26T22:26:09+00:00',
    currentEta: '2024-07-26T22:11:44+00:00',
    orderNumber: '1001277304',
    orderItems: [
      {
        itemName: 'RAPID MAX HP 200 40A 500',
        quantity: 50000.0,
        lineNumber: 10,
        itemNumber: '000000000107551872',
      },
    ],
    distributionId: '21394a5c-62fc-48a4-bec2-745e26056826',
    status: OrderShipmentStatus.ON_ROUTE,
    dispatchDate: '2024-07-25T00:00:00+00:00',
    plantName: 'Bergneset',
    plantId: '1FBT',
    initialEta: dayjs().add(4, 'days').toISOString(),
    arrivalTime: '',
  },
  {
    siteName: 'SETEVIKA NORD',
    siteErpId: '2800008262',
    globalSiteId: '79440a07-48cf-4fff-ade5-8cd588196b69',
    siteLocation: {
      latitude: 62.73835,
      longitude: 6.937667,
    },
    distributionStatus: DistributionStatus.NOT_STARTED,
    vessel: 'Orion Olympus',
    vesselLocation: {
      latitude: 64.94696166666667,
      longitude: 11.457813333333332,
    },
    etaAtShipmentStart: '',
    currentEta: '2024-08-04T16:45:03+00:00',
    orderNumber: '1001272785',
    orderItems: [
      {
        itemName: 'RAPID ADAPT 80 FLOW 40A 500',
        quantity: 5000.0,
        lineNumber: 10,
        itemNumber: '000000000130064321',
      },
    ],
    distributionId: '21c26603-168c-41e6-a9e3-f75991f3acc4',
    status: OrderShipmentStatus.LOADING,
    dispatchDate: '2024-08-03T00:00:00+00:00',
    plantName: 'Kristiansund',
    plantId: '2IRO',
    initialEta: dayjs().add(4, 'days').toISOString(),
    arrivalTime: '',
  },
  {
    siteName: 'KYRØYENE',
    siteErpId: '2000069890',
    globalSiteId: 'b22f2e8a-647d-481d-b2b4-c9f35804f8d6',
    siteLocation: {
      latitude: 64.764017,
      longitude: 10.806633,
    },
    distributionStatus: DistributionStatus.NOT_STARTED,
    vessel: 'Biostar',
    vesselLocation: {
      latitude: 63.152365,
      longitude: 8.339815,
    },
    etaAtShipmentStart: '',
    currentEta: '2024-07-30T11:50:29+00:00',
    orderNumber: '1001259079',
    orderItems: [
      {
        itemName: 'ST102 1000 50A 500',
        quantity: 140000.0,
        lineNumber: 10,
        itemNumber: '000000000130090078',
      },
    ],
    distributionId: '21d99324-2672-4e43-856a-3bc931e93471',
    status: OrderShipmentStatus.LOADING,
    dispatchDate: '2024-07-29T00:00:00+00:00',
    plantName: 'Halsa',
    plantId: '1FBU',
    initialEta: dayjs().add(4, 'days').toISOString(),
    arrivalTime: '',
  },
  {
    siteName: 'DRYNA',
    siteErpId: '2800007943',
    globalSiteId: '4b3ae69a-39cb-4fcb-b6fd-b4b7f00fb451',
    siteLocation: {
      latitude: 62.6444,
      longitude: 6.5568,
    },
    distributionStatus: DistributionStatus.NOT_STARTED,
    vessel: 'Terneskjær',
    vesselLocation: {
      latitude: 59.19812666666667,
      longitude: 5.797698333333333,
    },
    etaAtShipmentStart: '',
    currentEta: '2024-08-04T09:09:15+00:00',
    orderNumber: '1001271020',
    orderItems: [
      {
        itemName: 'HARMONY 2500 0.175PF NP750',
        quantity: 100500.0,
        lineNumber: 10,
        itemNumber: '000000000130040424',
      },
    ],
    distributionId: '22e32407-7dc9-4f07-af89-c1ae74235452',
    status: OrderShipmentStatus.LOADING,
    dispatchDate: '2024-08-03T00:00:00+00:00',
    plantName: 'Gangstøvika',
    plantId: '2IRP',
    initialEta: dayjs().add(4, 'days').toISOString(),
    arrivalTime: '',
  },
  {
    siteName: 'ØYRA',
    siteErpId: '2800007946',
    globalSiteId: '812be6e3-ce80-45df-85c0-baae77d140da',
    siteLocation: {
      latitude: 70.774767,
      longitude: 27.2185,
    },
    distributionStatus: DistributionStatus.FINISHED,
    vessel: 'Rotsund',
    vesselLocation: {
      latitude: 70.63734500000001,
      longitude: 30.508294999999997,
    },
    etaAtShipmentStart: '2024-07-24T22:38:11+00:00',
    currentEta: '2024-07-24T21:49:34+00:00',
    orderNumber: '1001266801',
    orderItems: [
      {
        itemName: 'RAPID MAX HP 200 40A 500',
        quantity: 40000.0,
        lineNumber: 50,
        itemNumber: '000000000107551872',
      },
      {
        itemName: 'RAPID 80 ADAPT 40A 500',
        quantity: 12000.0,
        lineNumber: 40,
        itemNumber: '000000000107555138',
      },
    ],
    distributionId: '2469d7fd-8ead-4a15-b578-1c0357818288',
    status: OrderShipmentStatus.DELIVERED,
    dispatchDate: '2024-07-23T00:00:00+00:00',
    plantName: 'Bergneset',
    plantId: '1FBT',
    initialEta: dayjs().add(4, 'days').toISOString(),
    arrivalTime: '2024-07-24T22:13:16+00:00',
    documentIds: ['7df43f90-9978-41a4-a1d8-2ae2fa5f3a0b', '26f043f1-66c1-4618-8df0-0b654e573a61'],
  },
  {
    siteName: 'BØRFJORD',
    siteErpId: '2000077132',
    globalSiteId: '57795338-414b-453f-92de-8f0ff45f77a2',
    siteLocation: {
      latitude: 70.645333,
      longitude: 22.694317,
    },
    distributionStatus: DistributionStatus.NOT_STARTED,
    vessel: 'With Frohavet',
    vesselLocation: {
      latitude: 70.76188666666667,
      longitude: 24.221655,
    },
    etaAtShipmentStart: '',
    currentEta: '2024-08-01T16:36:19+00:00',
    orderNumber: '1001279618',
    orderItems: [
      {
        itemName: 'ST102 1000 50A 500',
        quantity: 107000.0,
        lineNumber: 20,
        itemNumber: '000000000130090078',
      },
    ],
    distributionId: '24737392-dd15-484d-b564-8813d1988f04',
    status: OrderShipmentStatus.LOADING,
    dispatchDate: '2024-07-31T00:00:00+00:00',
    plantName: 'Bergneset',
    plantId: '1FBT',
    initialEta: dayjs().add(4, 'days').toISOString(),
    arrivalTime: '',
  },
  {
    siteName: 'FARTØYVIKA',
    siteErpId: '2000069868',
    globalSiteId: '2f38c961-6125-4d62-a608-7f014cc3ae73',
    siteLocation: {
      latitude: 70.828517,
      longitude: 24.450483,
    },
    distributionStatus: DistributionStatus.FINISHED,
    vessel: 'Rotsund',
    vesselLocation: {
      latitude: 70.63734500000001,
      longitude: 30.508294999999997,
    },
    etaAtShipmentStart: '2024-07-24T13:12:04+00:00',
    currentEta: '2024-07-24T12:09:41+00:00',
    orderNumber: '1001266799',
    orderItems: [
      {
        itemName: 'ST102 1000 50A 500',
        quantity: 207500.0,
        lineNumber: 20,
        itemNumber: '000000000130090078',
      },
    ],
    distributionId: '29ed78fe-cec9-4430-a788-50e0ffb3e9b8',
    status: OrderShipmentStatus.DELIVERED,
    dispatchDate: '2024-07-23T00:00:00+00:00',
    plantName: 'Bergneset',
    plantId: '1FBT',
    initialEta: dayjs().add(4, 'days').toISOString(),
    arrivalTime: '2024-07-24T12:15:09+00:00',
  },
  {
    siteName: 'LYBERGSVIKA',
    siteErpId: '2800007440',
    globalSiteId: '3733aceb-2e17-4043-a84a-f1ece42dab6d',
    siteLocation: {
      latitude: 62.64515,
      longitude: 7.448583,
    },
    distributionStatus: DistributionStatus.NOT_STARTED,
    vessel: 'Terneskjær',
    vesselLocation: {
      latitude: 59.19812666666667,
      longitude: 5.797698333333333,
    },
    etaAtShipmentStart: '2024-07-29T01:01:45+00:00',
    currentEta: '2024-07-29T02:27:43+00:00',
    orderNumber: '1001222082',
    orderItems: [
      {
        itemName: 'RAPID MAX HP 200 40A 500',
        quantity: 72000.0,
        lineNumber: 10,
        itemNumber: '000000000107551872',
      },
    ],
    distributionId: '2c127abb-35eb-4803-947e-21f48feb7a72',
    status: OrderShipmentStatus.ON_ROUTE,
    dispatchDate: '2024-07-27T00:00:00+00:00',
    plantName: 'Gangstøvika',
    plantId: '2IRP',
    initialEta: dayjs().add(4, 'days').toISOString(),
    arrivalTime: '',
  },
  {
    siteName: 'LANGNESET',
    siteErpId: '2000065174',
    globalSiteId: '308c78ce-c11b-4dbb-91d6-a3c546905098',
    siteLocation: {
      latitude: 70.051267,
      longitude: 19.76845,
    },
    distributionStatus: DistributionStatus.FINISHED,
    vessel: 'Eidsvaag Opal',
    vesselLocation: {
      latitude: 69.78573166666666,
      longitude: 18.307843333333334,
    },
    etaAtShipmentStart: '2024-07-26T19:12:59+00:00',
    currentEta: '2024-07-26T18:58:34+00:00',
    orderNumber: '1001270107',
    orderItems: [
      {
        itemName: 'RAPID MAX HP 200 40A 500',
        quantity: 44500.0,
        lineNumber: 20,
        itemNumber: '000000000107551872',
      },
    ],
    distributionId: '2dae7938-495b-480d-a6b8-4e198a8f437d',
    status: OrderShipmentStatus.ON_ROUTE,
    dispatchDate: '2024-07-25T00:00:00+00:00',
    plantName: 'Bergneset',
    plantId: '1FBT',
    initialEta: dayjs().add(4, 'days').toISOString(),
    arrivalTime: '',
  },
  {
    siteName: 'ÅRSETHFJORDEN',
    siteErpId: '2000069887',
    globalSiteId: '241b47fd-cbb6-476b-a5d1-e22f9c74ef9c',
    siteLocation: {
      latitude: 65.008183,
      longitude: 11.746417,
    },
    distributionStatus: DistributionStatus.NOT_STARTED,
    vessel: 'Aqua Fjell',
    vesselLocation: {
      latitude: 64.85982666666666,
      longitude: 11.238265,
    },
    etaAtShipmentStart: '',
    currentEta: '2024-07-28T16:56:17+00:00',
    orderNumber: '1001261003',
    orderItems: [
      {
        itemName: 'RAPID MAX HP 200 40A BLK',
        quantity: 30000.0,
        lineNumber: 10,
        itemNumber: '000000000107553040',
      },
    ],
    distributionId: '2fbcf733-fff7-4fc3-b403-c6e43af27c33',
    status: OrderShipmentStatus.LOADING,
    dispatchDate: '2024-07-27T00:00:00+00:00',
    plantName: 'Halsa',
    plantId: '1FBU',
    initialEta: dayjs().add(4, 'days').toISOString(),
    arrivalTime: '',
  },
  {
    siteName: 'NÆRINGSBUKTA',
    siteErpId: '2000069856',
    globalSiteId: 'ae68c309-56c1-4b77-a7ad-b8cd70f97107',
    siteLocation: {
      latitude: 70.658917,
      longitude: 22.642417,
    },
    distributionStatus: DistributionStatus.FINISHED,
    vessel: 'With Frohavet',
    vesselLocation: {
      latitude: 70.76188666666667,
      longitude: 24.221655,
    },
    etaAtShipmentStart: '2024-07-25T17:04:03+00:00',
    currentEta: '2024-07-25T16:59:39+00:00',
    orderNumber: '1001267692',
    orderItems: [
      {
        itemName: 'ST102 1000 50A 500',
        quantity: 65000.0,
        lineNumber: 20,
        itemNumber: '000000000130090078',
      },
    ],
    distributionId: '30734946-0f35-42d1-a0bf-7304c6af7d43',
    status: OrderShipmentStatus.DELIVERED,
    dispatchDate: '2024-07-24T00:00:00+00:00',
    plantName: 'Bergneset',
    plantId: '1FBT',
    initialEta: dayjs().add(4, 'days').toISOString(),
    arrivalTime: '2024-07-25T16:38:15+00:00',
    documentIds: undefined,
  },
  {
    siteName: 'VEIDNES',
    siteErpId: '2800008259',
    globalSiteId: '460e33f6-01a8-45d9-8661-229cf9384c0e',
    siteLocation: {
      latitude: 70.539917,
      longitude: 30.136583,
    },
    distributionStatus: DistributionStatus.FINISHED,
    vessel: 'Rotsund',
    vesselLocation: {
      latitude: 70.63734500000001,
      longitude: 30.508294999999997,
    },
    etaAtShipmentStart: '2024-07-25T07:54:30+00:00',
    currentEta: '2024-07-25T08:42:53+00:00',
    orderNumber: '1001266800',
    orderItems: [
      {
        itemName: 'ST102 1000 50A 500',
        quantity: 147500.0,
        lineNumber: 20,
        itemNumber: '000000000130090078',
      },
    ],
    distributionId: '30c76e85-308c-4f2a-bb65-8360cf7c9ebc',
    status: OrderShipmentStatus.ON_ROUTE,
    dispatchDate: '2024-07-23T00:00:00+00:00',
    plantName: 'Bergneset',
    plantId: '1FBT',
    initialEta: dayjs().add(4, 'days').toISOString(),
    arrivalTime: '',
  },
  {
    siteName: 'SETEVIKA',
    siteErpId: '2800007740',
    globalSiteId: 'cbd29d76-7776-42d1-a715-7ba4cc693667',
    siteLocation: {
      latitude: 62.728067,
      longitude: 6.939283,
    },
    distributionStatus: DistributionStatus.NOT_STARTED,
    vessel: 'Orion Olympus',
    vesselLocation: {
      latitude: 64.94696166666667,
      longitude: 11.457813333333332,
    },
    etaAtShipmentStart: '',
    currentEta: '2024-08-04T16:52:51+00:00',
    orderNumber: '1001272784',
    orderItems: [
      {
        itemName: 'RAPID ADAPT 80 FLOW 40A 500',
        quantity: 10000.0,
        lineNumber: 10,
        itemNumber: '000000000130064321',
      },
    ],
    distributionId: '31b7f690-9d7e-4f4c-ab81-3652a3d4f309',
    status: OrderShipmentStatus.LOADING,
    dispatchDate: '2024-08-03T00:00:00+00:00',
    plantName: 'Kristiansund',
    plantId: '2IRO',
    initialEta: dayjs().add(4, 'days').toISOString(),
    arrivalTime: '',
  },
  {
    siteName: 'SALATSKJÆRA',
    siteErpId: '2800008260',
    globalSiteId: '598b1dac-b074-4a85-9e52-9986a1035bec',
    siteLocation: {
      latitude: 63.90485,
      longitude: 8.589133,
    },
    distributionStatus: DistributionStatus.NOT_STARTED,
    vessel: 'Aqua Fjell',
    vesselLocation: {
      latitude: 64.85982666666666,
      longitude: 11.238265,
    },
    etaAtShipmentStart: '2024-07-25T15:05:15+00:00',
    currentEta: '2024-07-25T18:25:37+00:00',
    orderNumber: '1001234110',
    orderItems: [
      {
        itemName: 'ST102 1000 50A BLK',
        quantity: 100000.0,
        lineNumber: 10,
        itemNumber: '000000000130090079',
      },
    ],
    distributionId: '348f1bf4-fc67-47f3-afa2-ae88c80eae99',
    status: OrderShipmentStatus.DELIVERED,
    dispatchDate: '2024-07-23T00:00:00+00:00',
    plantName: 'Florø',
    plantId: '1FBS',
    initialEta: dayjs().add(4, 'days').toISOString(),
    arrivalTime: '2024-07-25T18:05:07+00:00',
    documentIds: ['7df43f90-9978-41a4-a1d8-2ae2fa5f3a0b', '26f043f1-66c1-4618-8df0-0b654e573a61'],
  },
  {
    siteName: 'KLUBBEN',
    siteErpId: '2000069848',
    globalSiteId: '88323045-1a7a-41c7-a18b-7c6dfe97edcd',
    siteLocation: {
      latitude: 70.663967,
      longitude: 22.6224,
    },
    distributionStatus: DistributionStatus.NOT_STARTED,
    vessel: 'With Frohavet',
    vesselLocation: {
      latitude: 70.76188666666667,
      longitude: 24.221655,
    },
    etaAtShipmentStart: '',
    currentEta: '2024-08-01T15:16:19+00:00',
    orderNumber: '1001279620',
    orderItems: [
      {
        itemName: 'ST102 1000 50A 500',
        quantity: 90500.0,
        lineNumber: 20,
        itemNumber: '000000000130090078',
      },
    ],
    distributionId: '35ebd0d5-023e-42ab-b9e5-9037d34640b2',
    status: OrderShipmentStatus.LOADING,
    dispatchDate: '2024-07-31T00:00:00+00:00',
    plantName: 'Bergneset',
    plantId: '1FBT',
    initialEta: dayjs().add(4, 'days').toISOString(),
    arrivalTime: '',
  },
  {
    siteName: 'MORTENSNES',
    siteErpId: '2000069842',
    globalSiteId: 'c0cfd9bc-8bdd-40c7-b2d5-308b8c83ad30',
    siteLocation: {
      latitude: 70.124217,
      longitude: 23.223833,
    },
    distributionStatus: DistributionStatus.NOT_STARTED,
    vessel: '',
    vesselLocation: {
      longitude: null,
      latitude: null,
    },
    etaAtShipmentStart: '',
    currentEta: '2024-07-26T16:54:06+00:00',
    orderNumber: '1001251928',
    orderItems: [
      {
        itemName: 'RAPID MAX HP 200 40A 500',
        quantity: 1000.0,
        lineNumber: 30,
        itemNumber: '000000000107551872',
      },
      {
        itemName: 'SLICE 5MG/KG 200',
        quantity: 53500.0,
        lineNumber: 20,
        itemNumber: '000000000107553000',
      },
    ],
    distributionId: '3aaa0393-b538-4290-8aec-6b439723e85a',
    status: OrderShipmentStatus.LOADING,
    dispatchDate: '2024-08-03T00:00:00+00:00',
    plantName: 'Bergneset',
    plantId: '1FBT',
    initialEta: dayjs().add(4, 'days').toISOString(),
    arrivalTime: '',
  },
  {
    siteName: 'DANIELSVIKA',
    siteErpId: '2000069820',
    globalSiteId: '42d1d74f-8b70-4a17-8d9b-3401ca800346',
    siteLocation: {
      latitude: 70.670583,
      longitude: 24.488767,
    },
    distributionStatus: DistributionStatus.FINISHED,
    vessel: 'With Frohavet',
    vesselLocation: {
      latitude: 70.76188666666667,
      longitude: 24.221655,
    },
    etaAtShipmentStart: '2024-07-26T06:06:28+00:00',
    currentEta: '2024-07-26T06:26:52+00:00',
    orderNumber: '1001267688',
    orderItems: [
      {
        itemName: 'ST102 1000 50A 500',
        quantity: 188500.0,
        lineNumber: 20,
        itemNumber: '000000000130090078',
      },
    ],
    distributionId: '3ca7c729-e6c0-44e9-abde-a1a9d04faf52',
    status: OrderShipmentStatus.DELIVERED,
    dispatchDate: '2024-07-24T00:00:00+00:00',
    plantName: 'Bergneset',
    plantId: '1FBT',
    initialEta: dayjs().add(4, 'days').toISOString(),
    arrivalTime: '2024-07-26T06:00:15+00:00',
    documentIds: ['7df43f90-9978-41a4-a1d8-2ae2fa5f3a0b', '26f043f1-66c1-4618-8df0-0b654e573a61'],
  },
  {
    siteName: 'BORVIKA',
    siteErpId: '2800008258',
    globalSiteId: '1c9cde13-8929-4894-ab64-0cb93be5b128',
    siteLocation: {
      latitude: 70.756667,
      longitude: 23.4353,
    },
    distributionStatus: DistributionStatus.NOT_STARTED,
    vessel: 'Rotsund',
    vesselLocation: {
      latitude: 70.63734500000001,
      longitude: 30.508294999999997,
    },
    etaAtShipmentStart: '',
    currentEta: '2024-07-29T03:39:12+00:00',
    orderNumber: '1001274247',
    orderItems: [
      {
        itemName: 'ST102 1000 50A 500',
        quantity: 17000.0,
        lineNumber: 20,
        itemNumber: '000000000130090078',
      },
    ],
    distributionId: '3f7dc38a-4015-4f38-8345-e7367db1c897',
    status: OrderShipmentStatus.LOADING,
    dispatchDate: '2024-07-27T00:00:00+00:00',
    plantName: '',
    plantId: '',
    initialEta: dayjs().add(4, 'days').toISOString(),
    arrivalTime: '',
  },
  {
    siteName: 'EITERFJORDEN',
    siteErpId: '2000069859',
    globalSiteId: 'fada7d80-8f6b-40e0-89d3-d3f2342c4e54',
    siteLocation: {
      latitude: 64.971633,
      longitude: 11.723933,
    },
    distributionStatus: DistributionStatus.NOT_STARTED,
    vessel: 'Aqua Fjell',
    vesselLocation: {
      latitude: 64.85982666666666,
      longitude: 11.238265,
    },
    etaAtShipmentStart: '',
    currentEta: '2024-07-28T18:13:35+00:00',
    orderNumber: '1001263577',
    orderItems: [
      {
        itemName: 'RAPID MAX HP 500 50A BLK',
        quantity: 30000.0,
        lineNumber: 10,
        itemNumber: '000000000107555081',
      },
    ],
    distributionId: '402923d9-f181-4d32-abb5-49480555f4fa',
    status: OrderShipmentStatus.LOADING,
    dispatchDate: '2024-07-27T00:00:00+00:00',
    plantName: 'Halsa',
    plantId: '1FBU',
    initialEta: dayjs().add(4, 'days').toISOString(),
    arrivalTime: '',
  },
  {
    siteName: 'LYNGØY',
    siteErpId: '2000069881',
    globalSiteId: 'b0be0bd0-faa5-4304-83f4-7d14da594c38',
    siteLocation: {
      latitude: 64.81865,
      longitude: 10.935217,
    },
    distributionStatus: DistributionStatus.NOT_STARTED,
    vessel: 'Biostar',
    vesselLocation: {
      latitude: 63.152365,
      longitude: 8.339815,
    },
    etaAtShipmentStart: '',
    currentEta: '2024-07-30T08:49:57+00:00',
    orderNumber: '1001268609',
    orderItems: [
      {
        itemName: 'ST102 1000 50A 500',
        quantity: 200000.0,
        lineNumber: 10,
        itemNumber: '000000000130090078',
      },
    ],
    distributionId: '40979449-d4bb-4962-b7f8-9e728ceff1ff',
    status: OrderShipmentStatus.LOADING,
    dispatchDate: '2024-07-29T00:00:00+00:00',
    plantName: 'Halsa',
    plantId: '1FBU',
    initialEta: dayjs().add(4, 'days').toISOString(),
    arrivalTime: '',
  },
  {
    siteName: 'FURNESET',
    siteErpId: '2800008248',
    globalSiteId: 'e79bbb46-7eea-4b3e-b864-867634a7b908',
    siteLocation: {
      latitude: 62.6461,
      longitude: 7.101183,
    },
    distributionStatus: DistributionStatus.NOT_STARTED,
    vessel: 'Aqua Fjell',
    vesselLocation: {
      latitude: 64.85982666666666,
      longitude: 11.238265,
    },
    etaAtShipmentStart: '',
    currentEta: '2024-08-01T03:43:07+00:00',
    orderNumber: '1001243892',
    orderItems: [
      {
        itemName: 'ST102 1000 50A 500',
        quantity: 100000.0,
        lineNumber: 40,
        itemNumber: '000000000130090078',
      },
      {
        itemName: 'RAPID MAX HP 200 40A 500',
        quantity: 10000.0,
        lineNumber: 30,
        itemNumber: '000000000107551872',
      },
    ],
    distributionId: '417ada53-2cee-49d5-8867-7a54b6f21de4',
    status: OrderShipmentStatus.LOADING,
    dispatchDate: '2024-07-30T00:00:00+00:00',
    plantName: 'Florø',
    plantId: '1FBS',
    initialEta: dayjs().add(4, 'days').toISOString(),
    arrivalTime: '',
  },
  {
    siteName: 'FARMANNSØYA',
    siteErpId: '2800008242',
    globalSiteId: '13379072-a2ce-4330-968e-b56b0c75b347',
    siteLocation: {
      latitude: 64.184517,
      longitude: 10.1222,
    },
    distributionStatus: DistributionStatus.NOT_STARTED,
    vessel: 'Orion Olympus',
    vesselLocation: {
      latitude: 64.94696166666667,
      longitude: 11.457813333333332,
    },
    etaAtShipmentStart: '',
    currentEta: '2024-08-03T16:13:17+00:00',
    orderNumber: '1001270986',
    orderItems: [
      {
        itemName: 'ST102 1000 FLOW 50A BLK',
        quantity: 170000.0,
        lineNumber: 20,
        itemNumber: '000000000130091494',
      },
    ],
    distributionId: '4ad8150b-39c5-43c0-9740-29746ed8bcaf',
    status: OrderShipmentStatus.LOADING,
    dispatchDate: '2024-08-01T00:00:00+00:00',
    plantName: 'Halsa',
    plantId: '1FBU',
    initialEta: dayjs().add(4, 'days').toISOString(),
    arrivalTime: '',
  },
  {
    siteName: 'DANIELSVIKA',
    siteErpId: '2000069820',
    globalSiteId: '42d1d74f-8b70-4a17-8d9b-3401ca800346',
    siteLocation: {
      latitude: 70.670583,
      longitude: 24.488767,
    },
    distributionStatus: DistributionStatus.NOT_STARTED,
    vessel: 'With Frohavet',
    vesselLocation: {
      latitude: 70.76188666666667,
      longitude: 24.221655,
    },
    etaAtShipmentStart: '',
    currentEta: '2024-08-02T05:47:42+00:00',
    orderNumber: '1001279616',
    orderItems: [
      {
        itemName: 'ST102 1000 50A 500',
        quantity: 150000.0,
        lineNumber: 20,
        itemNumber: '000000000130090078',
      },
    ],
    distributionId: '4c5057d6-4056-4663-92cc-35527d2826b3',
    status: OrderShipmentStatus.LOADING,
    dispatchDate: '2024-07-31T00:00:00+00:00',
    plantName: 'Bergneset',
    plantId: '1FBT',
    initialEta: dayjs().add(4, 'days').toISOString(),
    arrivalTime: '',
  },
  {
    siteName: 'VÆRØYA',
    siteErpId: '2800008246',
    globalSiteId: '75c5c6bf-05d8-45ed-95c8-7f027b9a80b9',
    siteLocation: {
      latitude: 63.415967,
      longitude: 8.483883,
    },
    distributionStatus: DistributionStatus.NOT_STARTED,
    vessel: '',
    vesselLocation: {
      longitude: null,
      latitude: null,
    },
    etaAtShipmentStart: '',
    currentEta: '2024-07-31T20:09:34+00:00',
    orderNumber: '1001265552',
    orderItems: [
      {
        itemName: 'HARMONY 2500 0.175PF NP750',
        quantity: 139500.0,
        lineNumber: 10,
        itemNumber: '000000000130040424',
      },
    ],
    distributionId: '4cccd3ca-a6ab-4b8e-80f5-f7b1cb6928f1',
    status: OrderShipmentStatus.LOADING,
    dispatchDate: '2024-08-02T00:00:00+00:00',
    plantName: 'Kristiansund',
    plantId: '2IRO',
    initialEta: dayjs().add(4, 'days').toISOString(),
    arrivalTime: '',
  },
  {
    siteName: 'LYBERGSVIKA',
    siteErpId: '2800007440',
    globalSiteId: '3733aceb-2e17-4043-a84a-f1ece42dab6d',
    siteLocation: {
      latitude: 62.64515,
      longitude: 7.448583,
    },
    distributionStatus: DistributionStatus.NOT_STARTED,
    vessel: 'Terneskjær',
    vesselLocation: {
      latitude: 59.19812666666667,
      longitude: 5.797698333333333,
    },
    etaAtShipmentStart: '',
    currentEta: '2024-08-04T21:19:32+00:00',
    orderNumber: '1001259314',
    orderItems: [
      {
        itemName: 'RAPID MAX HP 200 40A 500',
        quantity: 60000.0,
        lineNumber: 10,
        itemNumber: '000000000107551872',
      },
      {
        itemName: 'RAPID MAX HP 500 50A 500',
        quantity: 30000.0,
        lineNumber: 20,
        itemNumber: '000000000107550941',
      },
    ],
    distributionId: '4ee1cc02-e162-4eea-b459-91a8c920391f',
    status: OrderShipmentStatus.LOADING,
    dispatchDate: '2024-08-03T00:00:00+00:00',
    plantName: 'Gangstøvika',
    plantId: '2IRP',
    initialEta: dayjs().add(4, 'days').toISOString(),
    arrivalTime: '',
  },
  {
    siteName: 'FARTØYVIKA',
    siteErpId: '2000069868',
    globalSiteId: '2f38c961-6125-4d62-a608-7f014cc3ae73',
    siteLocation: {
      latitude: 70.828517,
      longitude: 24.450483,
    },
    distributionStatus: DistributionStatus.NOT_STARTED,
    vessel: 'Rotsund',
    vesselLocation: {
      latitude: 70.63734500000001,
      longitude: 30.508294999999997,
    },
    etaAtShipmentStart: '',
    currentEta: '2024-07-31T16:45:30+00:00',
    orderNumber: '1001278637',
    orderItems: [
      {
        itemName: 'ST102 1000 50A 500',
        quantity: 176500.0,
        lineNumber: 20,
        itemNumber: '000000000130090078',
      },
    ],
    distributionId: '53b2cb79-d950-4bfa-a917-41465fe95a93',
    status: OrderShipmentStatus.LOADING,
    dispatchDate: '2024-07-30T00:00:00+00:00',
    plantName: 'Bergneset',
    plantId: '1FBT',
    initialEta: dayjs().add(4, 'days').toISOString(),
    arrivalTime: '',
  },
  {
    siteName: 'KRABBHOLMEN',
    siteErpId: '2800007941',
    globalSiteId: '2d5e1caf-7ff3-4281-a02b-f5aff8b2a444',
    siteLocation: {
      latitude: 63.944483,
      longitude: 9.8814,
    },
    distributionStatus: DistributionStatus.NOT_STARTED,
    vessel: 'Orion Olympus',
    vesselLocation: {
      latitude: 64.94696166666667,
      longitude: 11.457813333333332,
    },
    etaAtShipmentStart: '2024-07-26T22:29:45+00:00',
    currentEta: '2024-07-26T22:45:12+00:00',
    orderNumber: '1001201471',
    orderItems: [
      {
        itemName: 'RAPID 80 ADAPT 40A 500',
        quantity: 120000.0,
        lineNumber: 10,
        itemNumber: '000000000107555138',
      },
    ],
    distributionId: '53fb206d-aa28-4577-a506-7d35e8123598',
    status: OrderShipmentStatus.ON_ROUTE,
    dispatchDate: '2024-07-25T00:00:00+00:00',
    plantName: 'Halsa',
    plantId: '1FBU',
    initialEta: dayjs().add(1, 'days').toISOString(),
    arrivalTime: '',
  },
  {
    siteName: 'SMÆLINGEN',
    siteErpId: '2800030484',
    globalSiteId: 'e23b2b3e-2c05-4b6b-877f-e22215fa6fda',
    siteLocation: {
      latitude: 64.093917,
      longitude: 9.903667,
    },
    distributionStatus: DistributionStatus.NOT_STARTED,
    vessel: 'Aqua Fjell',
    vesselLocation: {
      latitude: 64.85982666666666,
      longitude: 11.238265,
    },
    etaAtShipmentStart: '',
    currentEta: '2024-07-29T13:24:51+00:00',
    orderNumber: '1001246026',
    orderItems: [
      {
        itemName: 'ST102 1000 50A BLK',
        quantity: 150000.0,
        lineNumber: 10,
        itemNumber: '000000000130090079',
      },
    ],
    distributionId: '54ebec56-d949-4909-9cbe-dd7dc41c68f3',
    status: OrderShipmentStatus.LOADING,
    dispatchDate: '2024-07-27T00:00:00+00:00',
    plantName: 'Halsa',
    plantId: '1FBU',
    initialEta: dayjs().add(4, 'days').toISOString(),
    arrivalTime: '',
  },
  {
    siteName: 'KVITELV',
    siteErpId: '2800030492',
    globalSiteId: 'c5ef0d9a-a265-491b-8321-a027553c3d1a',
    siteLocation: {
      latitude: 70.629167,
      longitude: 27.123317,
    },
    distributionStatus: DistributionStatus.FINISHED,
    vessel: 'Rotsund',
    vesselLocation: {
      latitude: 70.63734500000001,
      longitude: 30.508294999999997,
    },
    etaAtShipmentStart: '2024-07-24T21:21:32+00:00',
    currentEta: '2024-07-24T20:30:38+00:00',
    orderNumber: '1001266802',
    orderItems: [
      {
        itemName: 'RAPID MAX HP 200 40A 500',
        quantity: 39500.0,
        lineNumber: 20,
        itemNumber: '000000000107551872',
      },
    ],
    distributionId: '5ddec986-78cf-4c28-a67a-482e6fcf5f16',
    status: OrderShipmentStatus.DELIVERED,
    dispatchDate: '2024-07-23T00:00:00+00:00',
    plantName: 'Bergneset',
    plantId: '1FBT',
    initialEta: dayjs().add(4, 'days').toISOString(),
    arrivalTime: '2024-07-24T20:32:55+00:00',
    documentIds: [],
  },
  {
    siteName: 'ØYRA',
    siteErpId: '2800007946',
    globalSiteId: '812be6e3-ce80-45df-85c0-baae77d140da',
    siteLocation: {
      latitude: 70.774767,
      longitude: 27.2185,
    },
    distributionStatus: DistributionStatus.NOT_STARTED,
    vessel: 'Rotsund',
    vesselLocation: {
      latitude: 70.63734500000001,
      longitude: 30.508294999999997,
    },
    etaAtShipmentStart: '',
    currentEta: '2024-08-01T00:00:21+00:00',
    orderNumber: '1001278639',
    orderItems: [
      {
        itemName: 'RAPID MAX HP 200 40A 500',
        quantity: 70000.0,
        lineNumber: 40,
        itemNumber: '000000000107551872',
      },
    ],
    distributionId: '5e63f694-ea3e-4972-991e-ba6349c60e47',
    status: OrderShipmentStatus.LOADING,
    dispatchDate: '2024-07-30T00:00:00+00:00',
    plantName: 'Bergneset',
    plantId: '1FBT',
    initialEta: dayjs().add(4, 'days').toISOString(),
    arrivalTime: '',
  },
  {
    siteName: 'LANGNESET',
    siteErpId: '2000065174',
    globalSiteId: '308c78ce-c11b-4dbb-91d6-a3c546905098',
    siteLocation: {
      latitude: 70.051267,
      longitude: 19.76845,
    },
    distributionStatus: DistributionStatus.NOT_STARTED,
    vessel: 'Eidsvaag Opal',
    vesselLocation: {
      latitude: 69.78573166666666,
      longitude: 18.307843333333334,
    },
    etaAtShipmentStart: '',
    currentEta: '2024-08-02T21:46:11+00:00',
    orderNumber: '1001285064',
    orderItems: [
      {
        itemName: 'RAPID MAX HP 200 40A 500',
        quantity: 75000.0,
        lineNumber: 10,
        itemNumber: '000000000107551872',
      },
    ],
    distributionId: '5e7a2823-83ce-4ac3-9def-82934d1a0af3',
    status: OrderShipmentStatus.LOADING,
    dispatchDate: '2024-08-01T00:00:00+00:00',
    plantName: 'Bergneset',
    plantId: '1FBT',
    initialEta: dayjs().add(4, 'days').toISOString(),
    arrivalTime: '',
  },
  {
    siteName: 'SALATSKJÆRA',
    siteErpId: '2800008260',
    globalSiteId: '598b1dac-b074-4a85-9e52-9986a1035bec',
    siteLocation: {
      latitude: 63.90485,
      longitude: 8.589133,
    },
    distributionStatus: DistributionStatus.NOT_STARTED,
    vessel: 'Aqua Fjell',
    vesselLocation: {
      latitude: 64.85982666666666,
      longitude: 11.238265,
    },
    etaAtShipmentStart: '',
    currentEta: '2024-08-02T00:32:47+00:00',
    orderNumber: '1001278644',
    orderItems: [
      {
        itemName: 'ST102 1000 50A 500',
        quantity: 200000.0,
        lineNumber: 20,
        itemNumber: '000000000130090078',
      },
    ],
    distributionId: '601abb09-5cb1-4820-91d2-e5711e5f3d87',
    status: OrderShipmentStatus.LOADING,
    dispatchDate: '2024-07-30T00:00:00+00:00',
    plantName: 'Florø',
    plantId: '1FBS',
    initialEta: dayjs().add(4, 'days').toISOString(),
    arrivalTime: '',
  },
  {
    siteName: 'RATAREN',
    siteErpId: '2800007588',
    globalSiteId: '25dfa0fb-21a8-43e9-9ce0-a6157d889473',
    siteLocation: {
      latitude: 63.780583,
      longitude: 8.5176,
    },
    distributionStatus: DistributionStatus.NOT_STARTED,
    vessel: 'Aqua Fjell',
    vesselLocation: {
      latitude: 64.85982666666666,
      longitude: 11.238265,
    },
    etaAtShipmentStart: '2024-07-25T19:26:09+00:00',
    currentEta: '2024-07-25T22:50:52+00:00',
    orderNumber: '1001476604',
    orderItems: [
      {
        itemName: 'RAPID HP 1000 HQ 50A 500',
        quantity: 130000.0,
        lineNumber: 20,
        itemNumber: '000000000107553222',
      },
    ],
    distributionId: '608b1796-f9ee-415c-ae78-ddcb3aa2c2c3',
    status: OrderShipmentStatus.DELIVERED,
    dispatchDate: '2024-07-25T00:00:00+00:00',
    plantName: 'Gangstøvika',
    plantId: '2IRP',
    initialEta: dayjs().add(4, 'days').toISOString(),
    arrivalTime: '2024-07-25T23:00:01+00:00',
    documentIds: ['7df43f90-9978-41a4-a1d8-2ae2fa5f3a0b', '26f043f1-66c1-4618-8df0-0b654e573a61'],
  },
  {
    siteName: 'SETERNESET',
    siteErpId: '2800007950',
    globalSiteId: '55340232-916f-4932-9137-d5a0443ccb9f',
    siteLocation: {
      latitude: 62.673933,
      longitude: 7.31415,
    },
    distributionStatus: DistributionStatus.NOT_STARTED,
    vessel: 'Terneskjær',
    vesselLocation: {
      latitude: 59.19812666666667,
      longitude: 5.797698333333333,
    },
    etaAtShipmentStart: '2024-07-28T23:45:13+00:00',
    currentEta: '2024-07-29T01:11:11+00:00',
    orderNumber: '1001226685',
    orderItems: [
      {
        itemName: 'RAPID HP 1000 HQ 50A 500',
        quantity: 10000.0,
        lineNumber: 30,
        itemNumber: '000000000107553222',
      },
      {
        itemName: 'RAPID MAX HP 200 40A 500',
        quantity: 40000.0,
        lineNumber: 10,
        itemNumber: '000000000107551872',
      },
    ],
    distributionId: '64649d6e-1973-4261-9ce9-5c455d178ea1',
    status: OrderShipmentStatus.ON_ROUTE,
    dispatchDate: '2024-07-27T00:00:00+00:00',
    plantName: 'Gangstøvika',
    plantId: '2IRP',
    initialEta: dayjs().add(4, 'days').toISOString(),
    arrivalTime: '',
  },
  {
    siteName: 'FINNVIK',
    siteErpId: '2800008255',
    globalSiteId: 'f5baabb8-809b-4c4c-ac47-0e143a6540c2',
    siteLocation: {
      latitude: 69.892333,
      longitude: 18.807083,
    },
    distributionStatus: DistributionStatus.FINISHED,
    vessel: 'Eidsvaag Opal',
    vesselLocation: {
      latitude: 69.78573166666666,
      longitude: 18.307843333333334,
    },
    etaAtShipmentStart: dayjs().add(4, 'days').toISOString(),
    currentEta: dayjs().add(5, 'days').toISOString(),
    orderNumber: '1001270110',
    orderItems: [
      {
        itemName: 'RAPID MAX HP 500 50A 500',
        quantity: 119000.0,
        lineNumber: 40,
        itemNumber: '000000000107550941',
      },
      {
        itemName: 'RAPID MAX HP 200 40A 500',
        quantity: 5500.0,
        lineNumber: 30,
        itemNumber: '000000000107551872',
      },
    ],
    distributionId: '665f0b2c-749c-4e18-8eca-3a9a799b4f06',
    status: OrderShipmentStatus.ON_ROUTE,
    dispatchDate: dayjs().add(4, 'days').toISOString(),
    plantName: 'Bergneset',
    plantId: '1FBT',
    initialEta: dayjs().add(4, 'days').toISOString(),
    arrivalTime: '',
  },
  {
    siteName: 'MYRANE',
    siteErpId: '2800007949',
    globalSiteId: '45e83815-036a-4248-9ae8-905f5a2a08e3',
    siteLocation: {
      latitude: 62.6505,
      longitude: 6.726683,
    },
    distributionStatus: DistributionStatus.NOT_STARTED,
    vessel: 'Terneskjær',
    vesselLocation: {
      latitude: 59.19812666666667,
      longitude: 5.797698333333333,
    },
    etaAtShipmentStart: '2024-07-28T18:08:51+00:00',
    currentEta: '2024-07-28T19:34:49+00:00',
    orderNumber: '1001239194',
    orderItems: [
      {
        itemName: 'RAPID HP 1000 HQ 50A 500',
        quantity: 200000.0,
        lineNumber: 20,
        itemNumber: '000000000107553222',
      },
    ],
    distributionId: '6793267c-c80e-4c23-a30b-815e5ee54955',
    status: OrderShipmentStatus.ON_ROUTE,
    dispatchDate: '2024-07-27T00:00:00+00:00',
    plantName: 'Gangstøvika',
    plantId: '2IRP',
    initialEta: dayjs().add(4, 'days').toISOString(),
    arrivalTime: '',
  },
  {
    siteName: 'KLUBBEN',
    siteErpId: '2000069848',
    globalSiteId: '88323045-1a7a-41c7-a18b-7c6dfe97edcd',
    siteLocation: {
      latitude: 70.663967,
      longitude: 22.6224,
    },
    distributionStatus: DistributionStatus.FINISHED,
    vessel: 'With Frohavet',
    vesselLocation: {
      latitude: 70.76188666666667,
      longitude: 24.221655,
    },
    etaAtShipmentStart: '2024-07-25T17:55:19+00:00',
    currentEta: '2024-07-25T17:29:31+00:00',
    orderNumber: '1001267691',
    orderItems: [
      {
        itemName: 'ST102 1000 50A 500',
        quantity: 71500.0,
        lineNumber: 20,
        itemNumber: '000000000130090078',
      },
    ],
    distributionId: '67af2b4d-f2da-4657-987c-582069d15b45',
    status: OrderShipmentStatus.DELIVERED,
    dispatchDate: '2024-07-24T00:00:00+00:00',
    plantName: 'Bergneset',
    plantId: '1FBT',
    initialEta: dayjs().add(4, 'days').toISOString(),
    arrivalTime: '2024-07-25T17:42:02+00:00',
    documentIds: ['7df43f90-9978-41a4-a1d8-2ae2fa5f3a0b', '26f043f1-66c1-4618-8df0-0b654e573a61'],
  },
  {
    siteName: 'SETEVIKA NORD',
    siteErpId: '2800008262',
    globalSiteId: '79440a07-48cf-4fff-ade5-8cd588196b69',
    siteLocation: {
      latitude: 62.73835,
      longitude: 6.937667,
    },
    distributionStatus: DistributionStatus.NOT_STARTED,
    vessel: 'Orion Olympus',
    vesselLocation: {
      latitude: 64.94696166666667,
      longitude: 11.457813333333332,
    },
    etaAtShipmentStart: '2024-07-27T19:32:57+00:00',
    currentEta: '2024-07-27T19:48:24+00:00',
    orderNumber: '1001271131',
    orderItems: [
      {
        itemName: 'RAPID ADAPT 80 FLOW 40A 500',
        quantity: 30000.0,
        lineNumber: 10,
        itemNumber: '000000000130064321',
      },
    ],
    distributionId: '69c87ee2-9430-4f07-a1dc-a2a8237c670b',
    status: OrderShipmentStatus.ON_ROUTE,
    dispatchDate: '2024-07-27T00:00:00+00:00',
    plantName: 'Kristiansund',
    plantId: '2IRO',
    initialEta: dayjs().add(4, 'days').toISOString(),
    arrivalTime: '',
  },
  {
    siteName: 'GJÆSINGEN',
    siteErpId: '2800007940',
    globalSiteId: '64a1792d-6e52-4d50-9779-e26591fa71df',
    siteLocation: {
      latitude: 64.117617,
      longitude: 9.981417,
    },
    distributionStatus: DistributionStatus.NOT_STARTED,
    vessel: 'Orion Olympus',
    vesselLocation: {
      latitude: 64.94696166666667,
      longitude: 11.457813333333332,
    },
    etaAtShipmentStart: '',
    currentEta: '2024-08-03T18:28:27+00:00',
    orderNumber: '1001283183',
    orderItems: [
      {
        itemName: 'ST102 1000 50A BLK',
        quantity: 120000.0,
        lineNumber: 10,
        itemNumber: '000000000130090079',
      },
    ],
    distributionId: '6a14e6f9-75c1-4fa5-beed-4013bca7f6fb',
    status: OrderShipmentStatus.LOADING,
    dispatchDate: '2024-08-01T00:00:00+00:00',
    plantName: 'Halsa',
    plantId: '1FBU',
    initialEta: dayjs().add(4, 'days').toISOString(),
    arrivalTime: '',
  },
  {
    siteName: 'BONDEJORDA',
    siteErpId: '2800008254',
    globalSiteId: 'bf110b67-e002-45ff-b0f9-d2f9e705a775',
    siteLocation: {
      latitude: 70.816933,
      longitude: 27.564833,
    },
    distributionStatus: DistributionStatus.NOT_STARTED,
    vessel: 'Rotsund',
    vesselLocation: {
      latitude: 70.63734500000001,
      longitude: 30.508294999999997,
    },
    etaAtShipmentStart: '',
    currentEta: '2024-08-01T01:37:34+00:00',
    orderNumber: '1001278640',
    orderItems: [
      {
        itemName: 'RAPID MAX HP 200 40A 500',
        quantity: 9000.0,
        lineNumber: 20,
        itemNumber: '000000000107551872',
      },
    ],
    distributionId: '6d957e4d-2973-4da9-af6d-49c142081d41',
    status: OrderShipmentStatus.LOADING,
    dispatchDate: '2024-07-30T00:00:00+00:00',
    plantName: 'Bergneset',
    plantId: '1FBT',
    initialEta: dayjs().add(4, 'days').toISOString(),
    arrivalTime: '',
  },
  {
    siteName: 'LARSTANGEN',
    siteErpId: '2800007948',
    globalSiteId: '4a2f41d3-e90c-440c-9468-72778f1c56e8',
    siteLocation: {
      latitude: 70.084417,
      longitude: 20.090417,
    },
    distributionStatus: DistributionStatus.FINISHED,
    vessel: 'Eidsvaag Opal',
    vesselLocation: {
      latitude: 69.78573166666666,
      longitude: 18.307843333333334,
    },
    etaAtShipmentStart: '2024-07-26T23:53:49+00:00',
    currentEta: '2024-07-26T23:39:24+00:00',
    orderNumber: '1001270108',
    orderItems: [
      {
        itemName: 'ST102 1000 50A BLK',
        quantity: 230000.0,
        lineNumber: 10,
        itemNumber: '000000000130090079',
      },
    ],
    distributionId: '6e2a98d1-2b37-4ae5-b7e6-996291c73570',
    status: OrderShipmentStatus.ON_ROUTE,
    dispatchDate: '2024-07-25T00:00:00+00:00',
    plantName: 'Bergneset',
    plantId: '1FBT',
    initialEta: dayjs().add(4, 'days').toISOString(),
    arrivalTime: '',
  },
  {
    siteName: 'RUGGSTEIN',
    siteErpId: '2800008594',
    globalSiteId: '33b31491-1385-4a7d-b48b-140221ca0175',
    siteLocation: {
      latitude: 63.770083,
      longitude: 8.476033,
    },
    distributionStatus: DistributionStatus.NOT_STARTED,
    vessel: 'Aqua Fjell',
    vesselLocation: {
      latitude: 64.85982666666666,
      longitude: 11.238265,
    },
    etaAtShipmentStart: '',
    currentEta: '2024-08-01T17:01:55+00:00',
    orderNumber: '1001215320',
    orderItems: [
      {
        itemName: 'ST102 1000 50A 500',
        quantity: 150000.0,
        lineNumber: 30,
        itemNumber: '000000000130090078',
      },
    ],
    distributionId: '71633da3-33fa-4955-aaf7-e42ca845ad06',
    status: OrderShipmentStatus.LOADING,
    dispatchDate: '2024-07-30T00:00:00+00:00',
    plantName: 'Florø',
    plantId: '1FBS',
    initialEta: dayjs().add(4, 'days').toISOString(),
    arrivalTime: '',
  },
  {
    siteName: 'KVITHOLMEN',
    siteErpId: '2000056592',
    globalSiteId: '6908d54c-85f5-4726-8320-f20ae2b0950e',
    siteLocation: {
      latitude: 63.28102,
      longitude: 8.0932,
    },
    distributionStatus: DistributionStatus.NOT_STARTED,
    vessel: 'Orion Olympus',
    vesselLocation: {
      latitude: 64.94696166666667,
      longitude: 11.457813333333332,
    },
    etaAtShipmentStart: '2024-07-27T11:34:33+00:00',
    currentEta: '2024-07-27T11:50:00+00:00',
    orderNumber: '1001246846',
    orderItems: [
      {
        itemName: 'RAPID MAX HP 200 40A 500',
        quantity: 40000.0,
        lineNumber: 10,
        itemNumber: '000000000107551872',
      },
    ],
    distributionId: '7193c195-904f-42c9-ac43-5249610af797',
    status: OrderShipmentStatus.ON_ROUTE,
    dispatchDate: '2024-07-25T00:00:00+00:00',
    plantName: 'Halsa',
    plantId: '1FBU',
    initialEta: dayjs().add(4, 'days').toISOString(),
    arrivalTime: '',
  },
  {
    siteName: 'FURNESET',
    siteErpId: '2800008248',
    globalSiteId: 'e79bbb46-7eea-4b3e-b864-867634a7b908',
    siteLocation: {
      latitude: 62.6461,
      longitude: 7.101183,
    },
    distributionStatus: DistributionStatus.NOT_STARTED,
    vessel: 'Terneskjær',
    vesselLocation: {
      latitude: 59.19812666666667,
      longitude: 5.797698333333333,
    },
    etaAtShipmentStart: '',
    currentEta: '2024-08-04T19:19:14+00:00',
    orderNumber: '1001243862',
    orderItems: [
      {
        itemName: 'HARMONY 250 0.2PF NP750',
        quantity: 30000.0,
        lineNumber: 10,
        itemNumber: '000000000130040475',
      },
    ],
    distributionId: '7564f2fb-0dee-4d5d-b0c8-6007baacb2f6',
    status: OrderShipmentStatus.LOADING,
    dispatchDate: '2024-08-03T00:00:00+00:00',
    plantName: 'Gangstøvika',
    plantId: '2IRP',
    initialEta: dayjs().add(4, 'days').toISOString(),
    arrivalTime: '',
  },
  {
    siteName: 'KVITFLOGET',
    siteErpId: '2800007947',
    globalSiteId: 'f13adc55-705b-41a0-9254-0a0ba35dccef',
    siteLocation: {
      latitude: 69.145083,
      longitude: 17.6465,
    },
    distributionStatus: DistributionStatus.NOT_STARTED,
    vessel: 'Eidsvaag Opal',
    vesselLocation: {
      latitude: 69.78573166666666,
      longitude: 18.307843333333334,
    },
    etaAtShipmentStart: '',
    currentEta: '2024-07-30T05:35:16+00:00',
    orderNumber: '1001278209',
    orderItems: [
      {
        itemName: 'RAPID MAX HP 500 50A 500',
        quantity: 28000.0,
        lineNumber: 30,
        itemNumber: '000000000107550941',
      },
      {
        itemName: 'ST102 1000 50A BLK',
        quantity: 65500.0,
        lineNumber: 10,
        itemNumber: '000000000130090079',
      },
    ],
    distributionId: '7797370d-27a0-4529-900d-6b1b29e03d80',
    status: OrderShipmentStatus.LOADING,
    dispatchDate: '2024-07-29T00:00:00+00:00',
    plantName: 'Bergneset',
    plantId: '1FBT',
    initialEta: dayjs().add(4, 'days').toISOString(),
    arrivalTime: '',
  },
  {
    siteName: 'VEIDNES',
    siteErpId: '2800008259',
    globalSiteId: '460e33f6-01a8-45d9-8661-229cf9384c0e',
    siteLocation: {
      latitude: 70.539917,
      longitude: 30.136583,
    },
    distributionStatus: DistributionStatus.NOT_STARTED,
    vessel: 'Rotsund',
    vesselLocation: {
      latitude: 70.63734500000001,
      longitude: 30.508294999999997,
    },
    etaAtShipmentStart: '',
    currentEta: '2024-08-01T11:38:08+00:00',
    orderNumber: '1001278638',
    orderItems: [
      {
        itemName: 'ST102 1000 50A 500',
        quantity: 132500.0,
        lineNumber: 20,
        itemNumber: '000000000130090078',
      },
    ],
    distributionId: '7d18d7c9-5287-400e-be08-a262b5c1f01d',
    status: OrderShipmentStatus.LOADING,
    dispatchDate: '2024-07-30T00:00:00+00:00',
    plantName: 'Bergneset',
    plantId: '1FBT',
    initialEta: dayjs().add(4, 'days').toISOString(),
    arrivalTime: '',
  },
  {
    siteName: 'KVITELV',
    siteErpId: '2800030492',
    globalSiteId: 'c5ef0d9a-a265-491b-8321-a027553c3d1a',
    siteLocation: {
      latitude: 70.629167,
      longitude: 27.123317,
    },
    distributionStatus: DistributionStatus.NOT_STARTED,
    vessel: 'Rotsund',
    vesselLocation: {
      latitude: 70.63734500000001,
      longitude: 30.508294999999997,
    },
    etaAtShipmentStart: '',
    currentEta: '2024-08-01T03:16:03+00:00',
    orderNumber: '1001278641',
    orderItems: [
      {
        itemName: 'RAPID MAX HP 200 40A 500',
        quantity: 35000.0,
        lineNumber: 20,
        itemNumber: '000000000107551872',
      },
    ],
    distributionId: '80e1ee14-45d2-43e6-a4e0-5bdea9f3364b',
    status: OrderShipmentStatus.LOADING,
    dispatchDate: '2024-07-30T00:00:00+00:00',
    plantName: 'Bergneset',
    plantId: '1FBT',
    initialEta: dayjs().add(4, 'days').toISOString(),
    arrivalTime: '',
  },
  {
    siteName: 'HUMULEN',
    siteErpId: '2000069882',
    globalSiteId: '3410a3de-8adb-4f27-84ad-601b813a8a3f',
    siteLocation: {
      latitude: 64.94605,
      longitude: 11.372467,
    },
    distributionStatus: DistributionStatus.NOT_STARTED,
    vessel: 'Orion Olympus',
    vesselLocation: {
      latitude: 64.94696166666667,
      longitude: 11.457813333333332,
    },
    etaAtShipmentStart: '',
    currentEta: '2024-08-02T11:08:23+00:00',
    orderNumber: '1001277310',
    orderItems: [
      {
        itemName: 'ST102 1000 50A BLK',
        quantity: 100000.0,
        lineNumber: 20,
        itemNumber: '000000000130090079',
      },
    ],
    distributionId: '85196b73-141a-453c-98f5-77399e6cd76b',
    status: OrderShipmentStatus.LOADING,
    dispatchDate: '2024-08-01T00:00:00+00:00',
    plantName: 'Halsa',
    plantId: '1FBU',
    initialEta: dayjs().add(4, 'days').toISOString(),
    arrivalTime: '',
  },
  {
    siteName: 'HOSENØYAN',
    siteErpId: '2800007942',
    globalSiteId: '9d07dea6-8350-44af-8b5c-116e6ac733ec',
    siteLocation: {
      latitude: 64.085183,
      longitude: 9.884683,
    },
    distributionStatus: DistributionStatus.NOT_STARTED,
    vessel: 'Biostar',
    vesselLocation: {
      latitude: 63.152365,
      longitude: 8.339815,
    },
    etaAtShipmentStart: '',
    currentEta: '2024-08-01T05:54:06+00:00',
    orderNumber: '1001173144',
    orderItems: [
      {
        itemName: 'ST102 1000 50A 500',
        quantity: 60000.0,
        lineNumber: 30,
        itemNumber: '000000000130090078',
      },
    ],
    distributionId: '880e745d-bc29-467d-8acd-5c17c5946493',
    status: OrderShipmentStatus.LOADING,
    dispatchDate: '2024-07-29T00:00:00+00:00',
    plantName: 'Halsa',
    plantId: '1FBU',
    initialEta: dayjs().add(4, 'days').toISOString(),
    arrivalTime: '',
  },
  {
    siteName: 'ÅRNES',
    siteErpId: '2800008587',
    globalSiteId: '8bd3260d-eece-40c1-b199-5eb8462f566b',
    siteLocation: {
      latitude: 64.596367,
      longitude: 11.272917,
    },
    distributionStatus: DistributionStatus.NOT_STARTED,
    vessel: 'Orion Olympus',
    vesselLocation: {
      latitude: 64.94696166666667,
      longitude: 11.457813333333332,
    },
    etaAtShipmentStart: '',
    currentEta: '2024-07-30T15:03:07+00:00',
    orderNumber: '1001276303',
    orderItems: [
      {
        itemName: 'ST102 1000 50A BLK',
        quantity: 300000.0,
        lineNumber: 10,
        itemNumber: '000000000130090079',
      },
    ],
    distributionId: '8d1b1d7a-e178-4f52-9832-7acf84d78e5c',
    status: OrderShipmentStatus.LOADING,
    dispatchDate: '2024-07-28T00:00:00+00:00',
    plantName: 'Florø',
    plantId: '1FBS',
    initialEta: dayjs().add(4, 'days').toISOString(),
    arrivalTime: '',
  },
  {
    siteName: 'KORSNES',
    siteErpId: '2000070763',
    globalSiteId: '58b93357-f233-412f-9b8b-361c103d4224',
    siteLocation: {
      latitude: 69.986917,
      longitude: 19.931633,
    },
    distributionStatus: DistributionStatus.NOT_STARTED,
    vessel: 'Eidsvaag Opal',
    vesselLocation: {
      latitude: 69.78573166666666,
      longitude: 18.307843333333334,
    },
    etaAtShipmentStart: '',
    currentEta: '2024-08-02T23:14:42+00:00',
    orderNumber: '1001282217',
    orderItems: [
      {
        itemName: 'RAPID MAX HP 200 40A BLK',
        quantity: 97500.0,
        lineNumber: 10,
        itemNumber: '000000000107553040',
      },
    ],
    distributionId: '8ee0582a-8d70-4f1f-91d7-980b84dc7b10',
    status: OrderShipmentStatus.LOADING,
    dispatchDate: '2024-08-01T00:00:00+00:00',
    plantName: 'Bergneset',
    plantId: '1FBT',
    initialEta: dayjs().add(4, 'days').toISOString(),
    arrivalTime: '',
  },
  {
    siteName: 'REIRÅKLAKKEN',
    siteErpId: '2800008241',
    globalSiteId: 'b584164f-31e0-48cb-af00-e567d79343d7',
    siteLocation: {
      latitude: 63.44995,
      longitude: 8.167717,
    },
    distributionStatus: DistributionStatus.FINISHED,
    vessel: 'Orion Olympus',
    vesselLocation: {
      latitude: 64.94696166666667,
      longitude: 11.457813333333332,
    },
    etaAtShipmentStart: '2024-07-27T10:19:03+00:00',
    currentEta: '2024-07-27T10:34:30+00:00',
    orderNumber: '1001262647',
    orderItems: [
      {
        itemName: 'RAPID MAX HP 200 40A BLK',
        quantity: 60000.0,
        lineNumber: 10,
        itemNumber: '000000000107553040',
      },
      {
        itemName: 'RAPID MAX HP 500 50A 500',
        quantity: 50000.0,
        lineNumber: 30,
        itemNumber: '000000000107550941',
      },
    ],
    distributionId: '94e84dd6-032b-449d-909d-f7cdef93016f',
    status: OrderShipmentStatus.ON_ROUTE,
    dispatchDate: '2024-07-25T00:00:00+00:00',
    plantName: 'Halsa',
    plantId: '1FBU',
    initialEta: dayjs().add(4, 'days').toISOString(),
    arrivalTime: '',
  },
  {
    siteName: 'FINNVIK',
    siteErpId: '2800008255',
    globalSiteId: 'f5baabb8-809b-4c4c-ac47-0e143a6540c2',
    siteLocation: {
      latitude: 69.892333,
      longitude: 18.807083,
    },
    distributionStatus: DistributionStatus.NOT_STARTED,
    vessel: 'Eidsvaag Opal',
    vesselLocation: {
      latitude: 69.78573166666666,
      longitude: 18.307843333333334,
    },
    etaAtShipmentStart: '',
    currentEta: '2024-08-02T13:00:14+00:00',
    orderNumber: '1001282219',
    orderItems: [
      {
        itemName: 'RAPID MAX HP 500 50A BLK',
        quantity: 123500.0,
        lineNumber: 10,
        itemNumber: '000000000107555081',
      },
      {
        itemName: 'RAPID MAX HP 200 40A 500',
        quantity: 4000.0,
        lineNumber: 30,
        itemNumber: '000000000107551872',
      },
    ],
    distributionId: '988bfaba-93ef-4672-8acf-c3a0b8a7cf19',
    status: OrderShipmentStatus.LOADING,
    dispatchDate: '2024-08-01T00:00:00+00:00',
    plantName: 'Bergneset',
    plantId: '1FBT',
    initialEta: dayjs().add(4, 'days').toISOString(),
    arrivalTime: '',
  },
  {
    siteName: 'VÆRØYA',
    siteErpId: '2800008246',
    globalSiteId: '75c5c6bf-05d8-45ed-95c8-7f027b9a80b9',
    siteLocation: {
      latitude: 63.415967,
      longitude: 8.483883,
    },
    distributionStatus: DistributionStatus.FINISHED,
    vessel: 'Biostar',
    vesselLocation: {
      latitude: 63.152365,
      longitude: 8.339815,
    },
    etaAtShipmentStart: '2024-07-26T03:59:34+00:00',
    currentEta: '2024-07-28T01:16:17+00:00',
    orderNumber: '1001214572',
    orderItems: [
      {
        itemName: 'HARMONY 2500 0.175PF NP750',
        quantity: 100500.0,
        lineNumber: 30,
        itemNumber: '000000000130040424',
      },
    ],
    distributionId: '98d84d3e-4acd-471f-832f-f71d11241cc6',
    status: OrderShipmentStatus.LOADING,
    dispatchDate: '2024-07-26T00:00:00+00:00',
    plantName: 'Kristiansund',
    plantId: '2IRO',
    initialEta: dayjs().add(4, 'days').toISOString(),
    arrivalTime: '',
  },
  {
    siteName: 'RATAREN',
    siteErpId: '2800007588',
    globalSiteId: '25dfa0fb-21a8-43e9-9ce0-a6157d889473',
    siteLocation: {
      latitude: 63.780583,
      longitude: 8.5176,
    },
    distributionStatus: DistributionStatus.NOT_STARTED,
    vessel: 'Aqua Fjell',
    vesselLocation: {
      latitude: 64.85982666666666,
      longitude: 11.238265,
    },
    etaAtShipmentStart: '',
    currentEta: '2024-07-29T20:22:22+00:00',
    orderNumber: '1001220775',
    orderItems: [
      {
        itemName: 'ST102 1000 50A BLK',
        quantity: 150000.0,
        lineNumber: 20,
        itemNumber: '000000000130090079',
      },
    ],
    distributionId: '9a3370dc-6f02-4164-8ee5-2363bcfb4154',
    status: OrderShipmentStatus.LOADING,
    dispatchDate: '2024-07-27T00:00:00+00:00',
    plantName: 'Halsa',
    plantId: '1FBU',
    initialEta: dayjs().add(4, 'days').toISOString(),
    arrivalTime: '',
  },
  {
    siteName: 'HUMULEN',
    siteErpId: '2000069882',
    globalSiteId: '3410a3de-8adb-4f27-84ad-601b813a8a3f',
    siteLocation: {
      latitude: 64.94605,
      longitude: 11.372467,
    },
    distributionStatus: DistributionStatus.FINISHED,
    vessel: 'Orion Olympus',
    vesselLocation: {
      latitude: 64.94696166666667,
      longitude: 11.457813333333332,
    },
    etaAtShipmentStart: '2024-07-26T09:51:04+00:00',
    currentEta: '2024-07-26T10:06:31+00:00',
    orderNumber: '1001257193',
    orderItems: [
      {
        itemName: 'ST102 1000 50A BLK',
        quantity: 50000.0,
        lineNumber: 20,
        itemNumber: '000000000130090079',
      },
    ],
    distributionId: '9a84e273-699c-406d-b70d-4daa61610d43',
    status: OrderShipmentStatus.ON_ROUTE,
    dispatchDate: '2024-07-25T00:00:00+00:00',
    plantName: 'Halsa',
    plantId: '1FBU',
    initialEta: dayjs().add(4, 'days').toISOString(),
    arrivalTime: '',
  },
  {
    siteName: 'NORDNESBUKTA',
    siteErpId: '2800007589',
    globalSiteId: 'b6c30fba-b853-4816-b9cb-61aa8d274088',
    siteLocation: {
      latitude: 70.721533,
      longitude: 23.340933,
    },
    distributionStatus: DistributionStatus.FINISHED,
    vessel: 'With Frohavet',
    vesselLocation: {
      latitude: 70.76188666666667,
      longitude: 24.221655,
    },
    etaAtShipmentStart: '2024-07-25T22:31:28+00:00',
    currentEta: '2024-07-25T22:53:29+00:00',
    orderNumber: '1001280727',
    orderItems: [
      {
        itemName: 'ST102 1000 50A 500',
        quantity: 15000.0,
        lineNumber: 10,
        itemNumber: '000000000130090078',
      },
    ],
    distributionId: '9ae7e486-dd4b-46af-a062-5fc0af963448',
    status: OrderShipmentStatus.DELIVERED,
    dispatchDate: '2024-07-24T00:00:00+00:00',
    plantName: 'Bergneset',
    plantId: '1FBT',
    initialEta: dayjs().add(4, 'days').toISOString(),
    arrivalTime: '2024-07-25T22:36:01+00:00',
  },
  {
    siteName: 'SETERNESET',
    siteErpId: '2800007950',
    globalSiteId: '55340232-916f-4932-9137-d5a0443ccb9f',
    siteLocation: {
      latitude: 62.673933,
      longitude: 7.31415,
    },
    distributionStatus: DistributionStatus.NOT_STARTED,
    vessel: 'Terneskjær',
    vesselLocation: {
      latitude: 59.19812666666667,
      longitude: 5.797698333333333,
    },
    etaAtShipmentStart: '',
    currentEta: '2024-08-04T20:31:41+00:00',
    orderNumber: '1001226686',
    orderItems: [
      {
        itemName: 'RAPID MAX HP 200 40A 500',
        quantity: 20000.0,
        lineNumber: 10,
        itemNumber: '000000000107551872',
      },
    ],
    distributionId: 'ad2ab368-f8bb-48c7-a96b-93573ca20a71',
    status: OrderShipmentStatus.LOADING,
    dispatchDate: '2024-08-03T00:00:00+00:00',
    plantName: 'Gangstøvika',
    plantId: '2IRP',
    initialEta: dayjs().add(4, 'days').toISOString(),
    arrivalTime: '',
  },
  {
    siteName: 'LARSTANGEN',
    siteErpId: '2800007948',
    globalSiteId: '4a2f41d3-e90c-440c-9468-72778f1c56e8',
    siteLocation: {
      latitude: 70.084417,
      longitude: 20.090417,
    },
    distributionStatus: DistributionStatus.NOT_STARTED,
    vessel: 'Eidsvaag Opal',
    vesselLocation: {
      latitude: 69.78573166666666,
      longitude: 18.307843333333334,
    },
    etaAtShipmentStart: '',
    currentEta: '2024-08-03T01:13:27+00:00',
    orderNumber: '1001282216',
    orderItems: [
      {
        itemName: 'ST102 1000 50A BLK',
        quantity: 230000.0,
        lineNumber: 10,
        itemNumber: '000000000130090079',
      },
    ],
    distributionId: 'aeafd3ef-13b1-4054-a3db-627bf04c0879',
    status: OrderShipmentStatus.LOADING,
    dispatchDate: '2024-08-01T00:00:00+00:00',
    plantName: 'Bergneset',
    plantId: '1FBT',
    initialEta: dayjs().add(4, 'days').toISOString(),
    arrivalTime: '',
  },
  {
    siteName: 'GJÆSINGEN',
    siteErpId: '2800007940',
    globalSiteId: '64a1792d-6e52-4d50-9779-e26591fa71df',
    siteLocation: {
      latitude: 64.117617,
      longitude: 9.981417,
    },
    distributionStatus: DistributionStatus.NOT_STARTED,
    vessel: 'Orion Olympus',
    vesselLocation: {
      latitude: 64.94696166666667,
      longitude: 11.457813333333332,
    },
    etaAtShipmentStart: '2024-07-26T19:45:00+00:00',
    currentEta: '2024-07-26T20:00:27+00:00',
    orderNumber: '1001235044',
    orderItems: [
      {
        itemName: 'ST102 1000 50A BLK',
        quantity: 160000.0,
        lineNumber: 10,
        itemNumber: '000000000130090079',
      },
    ],
    distributionId: 'b2824427-0857-43b9-86d2-01b0c5604754',
    status: OrderShipmentStatus.ON_ROUTE,
    dispatchDate: '2024-07-25T00:00:00+00:00',
    plantName: 'Halsa',
    plantId: '1FBU',
    initialEta: dayjs().add(4, 'days').toISOString(),
    arrivalTime: '',
  },
  {
    siteName: 'SETEVIKA',
    siteErpId: '2800007740',
    globalSiteId: 'cbd29d76-7776-42d1-a715-7ba4cc693667',
    siteLocation: {
      latitude: 62.728067,
      longitude: 6.939283,
    },
    distributionStatus: DistributionStatus.NOT_STARTED,
    vessel: 'Orion Olympus',
    vesselLocation: {
      latitude: 64.94696166666667,
      longitude: 11.457813333333332,
    },
    etaAtShipmentStart: '2024-07-27T20:07:45+00:00',
    currentEta: '2024-07-27T20:23:12+00:00',
    orderNumber: '1001271223',
    orderItems: [
      {
        itemName: 'RAPID ADAPT 80 FLOW 40A 500',
        quantity: 30000.0,
        lineNumber: 10,
        itemNumber: '000000000130064321',
      },
    ],
    distributionId: 'b32b9823-79e6-4a7d-9202-cea468d9006d',
    status: OrderShipmentStatus.ON_ROUTE,
    dispatchDate: '2024-07-27T00:00:00+00:00',
    plantName: 'Kristiansund',
    plantId: '2IRO',
    initialEta: dayjs().add(4, 'days').toISOString(),
    arrivalTime: '',
  },
  {
    siteName: 'GJERDE',
    siteErpId: '2800008261',
    globalSiteId: '109dbb35-cbdc-4f93-8bda-f0790fc8f82c',
    siteLocation: {
      latitude: 63.299667,
      longitude: 8.4183,
    },
    distributionStatus: DistributionStatus.NOT_STARTED,
    vessel: 'Aqua Fjell',
    vesselLocation: {
      latitude: 64.85982666666666,
      longitude: 11.238265,
    },
    etaAtShipmentStart: '',
    currentEta: '2024-08-01T11:47:42+00:00',
    orderNumber: '1001263318',
    orderItems: [
      {
        itemName: 'HARMONY 500 0.2PF NP750',
        quantity: 80000.0,
        lineNumber: 10,
        itemNumber: '000000000130040452',
      },
      {
        itemName: 'RAPID MAX HP 500 FLOW 50A 500',
        quantity: 80000.0,
        lineNumber: 20,
        itemNumber: '000000000130064168',
      },
    ],
    distributionId: 'b891c565-531b-4b44-ba6f-4204ec72655b',
    status: OrderShipmentStatus.LOADING,
    dispatchDate: '2024-08-01T00:00:00+00:00',
    plantName: 'Gangstøvika',
    plantId: '2IRP',
    initialEta: dayjs().add(4, 'days').toISOString(),
    arrivalTime: '',
  },
  {
    siteName: 'MYRANE',
    siteErpId: '2800007949',
    globalSiteId: '45e83815-036a-4248-9ae8-905f5a2a08e3',
    siteLocation: {
      latitude: 62.6505,
      longitude: 6.726683,
    },
    distributionStatus: DistributionStatus.NOT_STARTED,
    vessel: 'Terneskjær',
    vesselLocation: {
      latitude: 59.19812666666667,
      longitude: 5.797698333333333,
    },
    etaAtShipmentStart: '',
    currentEta: '2024-08-04T15:59:45+00:00',
    orderNumber: '1001265133',
    orderItems: [
      {
        itemName: 'ST102 1000 50A 500',
        quantity: 120000.0,
        lineNumber: 20,
        itemNumber: '000000000130090078',
      },
    ],
    distributionId: 'b90daf1e-7ef7-401b-b6ee-3307cd225783',
    status: OrderShipmentStatus.LOADING,
    dispatchDate: '2024-08-03T00:00:00+00:00',
    plantName: 'Gangstøvika',
    plantId: '2IRP',
    initialEta: dayjs().add(4, 'days').toISOString(),
    arrivalTime: '',
  },
  {
    siteName: 'GJERDE',
    siteErpId: '2800008261',
    globalSiteId: '109dbb35-cbdc-4f93-8bda-f0790fc8f82c',
    siteLocation: {
      latitude: 63.299667,
      longitude: 8.4183,
    },
    distributionStatus: DistributionStatus.FINISHED,
    vessel: 'Aqua Fjell',
    vesselLocation: {
      latitude: 64.85982666666666,
      longitude: 11.238265,
    },
    etaAtShipmentStart: '2024-07-25T04:55:11+00:00',
    currentEta: '2024-07-26T01:36:52+00:00',
    orderNumber: '1001273138',
    orderItems: [
      {
        itemName: 'RAPID MAX HP 500 FLOW 50A BLK',
        quantity: 8000.0,
        lineNumber: 20,
        itemNumber: '000000000130064172',
      },
    ],
    distributionId: 'b932af40-6594-47ad-90e1-0d27737a4434',
    status: OrderShipmentStatus.ON_ROUTE,
    dispatchDate: '2024-07-20T00:00:00+00:00',
    plantName: 'Halsa',
    plantId: '1FBU',
    initialEta: dayjs().add(4, 'days').toISOString(),
    arrivalTime: '2024-07-25T07:25:28+00:00',
  },
  {
    siteName: 'RUGGSTEIN',
    siteErpId: '2800008594',
    globalSiteId: '33b31491-1385-4a7d-b48b-140221ca0175',
    siteLocation: {
      latitude: 63.770083,
      longitude: 8.476033,
    },
    distributionStatus: DistributionStatus.FINISHED,
    vessel: 'Aqua Fjell',
    vesselLocation: {
      latitude: 64.85982666666666,
      longitude: 11.238265,
    },
    etaAtShipmentStart: '2024-07-25T17:17:47+00:00',
    currentEta: '2024-07-25T20:29:38+00:00',
    orderNumber: '1001215318',
    orderItems: [
      {
        itemName: 'ST102 1000 50A BLK',
        quantity: 160000.0,
        lineNumber: 20,
        itemNumber: '000000000130090079',
      },
    ],
    distributionId: 'bf2b0df1-ff0c-4dd1-86ea-4662e6b43857',
    status: OrderShipmentStatus.DELIVERED,
    dispatchDate: '2024-07-23T00:00:00+00:00',
    plantName: 'Florø',
    plantId: '1FBS',
    initialEta: dayjs().add(4, 'days').toISOString(),
    arrivalTime: '2024-07-25T20:42:30+00:00',
  },
  {
    siteName: 'TRISTEINEN',
    siteErpId: '2800008243',
    globalSiteId: 'b1423f88-805e-4208-ab60-bade46a45c17',
    siteLocation: {
      latitude: 63.89373321,
      longitude: 9.822158804,
    },
    distributionStatus: DistributionStatus.NOT_STARTED,
    vessel: 'Aqua Fjell',
    vesselLocation: {
      latitude: 64.85982666666666,
      longitude: 11.238265,
    },
    etaAtShipmentStart: '',
    currentEta: '2024-07-29T16:52:47+00:00',
    orderNumber: '1001255074',
    orderItems: [
      {
        itemName: 'RAPID MAX HP 200 40A BLK',
        quantity: 40000.0,
        lineNumber: 10,
        itemNumber: '000000000107553040',
      },
    ],
    distributionId: 'bf6e2ae9-c942-47c2-8d2d-37c7c0f01b05',
    status: OrderShipmentStatus.LOADING,
    dispatchDate: '2024-07-27T00:00:00+00:00',
    plantName: 'Halsa',
    plantId: '1FBU',
    initialEta: dayjs().add(4, 'days').toISOString(),
    arrivalTime: '',
  },
  {
    siteName: 'HOSENØYAN',
    siteErpId: '2800007942',
    globalSiteId: '9d07dea6-8350-44af-8b5c-116e6ac733ec',
    siteLocation: {
      latitude: 64.085183,
      longitude: 9.884683,
    },
    distributionStatus: DistributionStatus.NOT_STARTED,
    vessel: '',
    vesselLocation: {
      longitude: null,
      latitude: null,
    },
    etaAtShipmentStart: '',
    currentEta: '2024-08-01T05:54:06+00:00',
    orderNumber: '1001253693',
    orderItems: [
      {
        itemName: 'HARMONY 1000 0.2PF NP750',
        quantity: 60000.0,
        lineNumber: 10,
        itemNumber: '000000000130040444',
      },
    ],
    distributionId: 'c1a997bd-4758-4bb6-9641-65bf4fd1b469',
    status: OrderShipmentStatus.LOADING,
    dispatchDate: '2024-08-02T00:00:00+00:00',
    plantName: 'Kristiansund',
    plantId: '2IRO',
    initialEta: dayjs().add(4, 'days').toISOString(),
    arrivalTime: '',
  },
  {
    siteName: 'VÆRØYA',
    siteErpId: '2800008246',
    globalSiteId: '75c5c6bf-05d8-45ed-95c8-7f027b9a80b9',
    siteLocation: {
      latitude: 63.415967,
      longitude: 8.483883,
    },
    distributionStatus: DistributionStatus.NOT_STARTED,
    vessel: 'Biostar',
    vesselLocation: {
      latitude: 63.152365,
      longitude: 8.339815,
    },
    etaAtShipmentStart: '',
    currentEta: '2024-07-31T20:09:34+00:00',
    orderNumber: '1001265549',
    orderItems: [
      {
        itemName: 'ST102 1000 50A 500',
        quantity: 160000.0,
        lineNumber: 20,
        itemNumber: '000000000130090078',
      },
    ],
    distributionId: 'c4757199-fd9c-4f70-8340-e3f0c2121dce',
    status: OrderShipmentStatus.LOADING,
    dispatchDate: '2024-07-29T00:00:00+00:00',
    plantName: 'Halsa',
    plantId: '1FBU',
    initialEta: dayjs().add(4, 'days').toISOString(),
    arrivalTime: '',
  },
  {
    siteName: 'LARSTANGEN',
    siteErpId: '2800007948',
    globalSiteId: '4a2f41d3-e90c-440c-9468-72778f1c56e8',
    siteLocation: {
      latitude: 70.084417,
      longitude: 20.090417,
    },
    distributionStatus: DistributionStatus.NOT_STARTED,
    vessel: 'Rotsund',
    vesselLocation: {
      latitude: 70.63734500000001,
      longitude: 30.508294999999997,
    },
    etaAtShipmentStart: '',
    currentEta: '2024-07-29T09:47:30+00:00',
    orderNumber: '1001274249',
    orderItems: [
      {
        itemName: 'ST102 1000 50A 500',
        quantity: 250000.0,
        lineNumber: 20,
        itemNumber: '000000000130090078',
      },
    ],
    distributionId: 'c5ad27e6-1d2a-4e19-9952-34deedf0f450',
    status: OrderShipmentStatus.LOADING,
    dispatchDate: '2024-07-27T00:00:00+00:00',
    plantName: 'Bergneset',
    plantId: '1FBT',
    initialEta: dayjs().add(4, 'days').toISOString(),
    arrivalTime: '',
  },
  {
    siteName: 'HOVDENAKKEN',
    siteErpId: '2800007744',
    globalSiteId: '142effc7-cacc-4ed0-b20c-297b0f236d21',
    siteLocation: {
      latitude: 70.81805,
      longitude: 27.49395,
    },
    distributionStatus: DistributionStatus.FINISHED,
    vessel: 'Rotsund',
    vesselLocation: {
      latitude: 70.63734500000001,
      longitude: 30.508294999999997,
    },
    etaAtShipmentStart: '2024-07-24T23:55:14+00:00',
    currentEta: '2024-07-24T23:30:19+00:00',
    orderNumber: '1001266798',
    orderItems: [
      {
        itemName: 'RAPID MAX HP 200 40A 500',
        quantity: 64000.0,
        lineNumber: 20,
        itemNumber: '000000000107551872',
      },
    ],
    distributionId: 'c642cf9c-a03f-46f6-958e-c4d267799af1',
    status: OrderShipmentStatus.DELIVERED,
    dispatchDate: '2024-07-23T00:00:00+00:00',
    plantName: 'Bergneset',
    plantId: '1FBT',
    initialEta: dayjs().add(4, 'days').toISOString(),
    arrivalTime: '2024-07-25T00:08:05+00:00',
  },
  {
    siteName: 'DANIELSVIKA',
    siteErpId: '2000069820',
    globalSiteId: '42d1d74f-8b70-4a17-8d9b-3401ca800346',
    siteLocation: {
      latitude: 70.670583,
      longitude: 24.488767,
    },
    distributionStatus: DistributionStatus.NOT_STARTED,
    vessel: 'Rotsund',
    vesselLocation: {
      latitude: 70.63734500000001,
      longitude: 30.508294999999997,
    },
    etaAtShipmentStart: '',
    currentEta: '2024-07-28T21:40:21+00:00',
    orderNumber: '1001274248',
    orderItems: [
      {
        itemName: 'ST102 1000 50A 500',
        quantity: 277000.0,
        lineNumber: 20,
        itemNumber: '000000000130090078',
      },
    ],
    distributionId: 'd1807242-9556-4ee0-a53c-7de24ecc3b0b',
    status: OrderShipmentStatus.LOADING,
    dispatchDate: '2024-07-27T00:00:00+00:00',
    plantName: 'Bergneset',
    plantId: '1FBT',
    initialEta: dayjs().add(4, 'days').toISOString(),
    arrivalTime: '',
  },
  {
    siteName: 'GJERDE',
    siteErpId: '2800008261',
    globalSiteId: '109dbb35-cbdc-4f93-8bda-f0790fc8f82c',
    siteLocation: {
      latitude: 63.299667,
      longitude: 8.4183,
    },
    distributionStatus: DistributionStatus.FINISHED,
    vessel: 'Aqua Fjell',
    vesselLocation: {
      latitude: 64.85982666666666,
      longitude: 11.238265,
    },
    etaAtShipmentStart: '2024-07-25T04:55:11+00:00',
    currentEta: '2024-07-26T01:36:52+00:00',
    orderNumber: '1001220821',
    orderItems: [
      {
        itemName: 'RAPID MAX HP 500 FLOW 50A BLK',
        quantity: 70000.0,
        lineNumber: 50,
        itemNumber: '000000000130064172',
      },
    ],
    distributionId: 'd18568fd-f6ce-43e3-95bc-4b5f623f5a66',
    status: OrderShipmentStatus.ON_ROUTE,
    dispatchDate: '2024-07-23T00:00:00+00:00',
    plantName: 'Florø',
    plantId: '1FBS',
    initialEta: dayjs().add(4, 'days').toISOString(),
    arrivalTime: '2024-07-25T07:25:28+00:00',
  },
  {
    siteName: 'SKOGSHAMN',
    siteErpId: '2800008253',
    globalSiteId: 'c6298a14-0b25-4a52-95a1-107639a23d8c',
    siteLocation: {
      latitude: 69.093017,
      longitude: 17.512567,
    },
    distributionStatus: DistributionStatus.NOT_STARTED,
    vessel: 'Eidsvaag Opal',
    vesselLocation: {
      latitude: 69.78573166666666,
      longitude: 18.307843333333334,
    },
    etaAtShipmentStart: '',
    currentEta: '2024-07-30T07:08:04+00:00',
    orderNumber: '1001278207',
    orderItems: [
      {
        itemName: 'ST102 1000 50A BLK',
        quantity: 186500.0,
        lineNumber: 10,
        itemNumber: '000000000130090079',
      },
    ],
    distributionId: 'd6b3167f-cb46-4dd4-8057-48b8ddcd6403',
    status: OrderShipmentStatus.LOADING,
    dispatchDate: '2024-07-29T00:00:00+00:00',
    plantName: 'Bergneset',
    plantId: '1FBT',
    initialEta: dayjs().add(4, 'days').toISOString(),
    arrivalTime: '',
  },
  {
    siteName: 'HOSENØYAN',
    siteErpId: '2800007942',
    globalSiteId: '9d07dea6-8350-44af-8b5c-116e6ac733ec',
    siteLocation: {
      latitude: 64.085183,
      longitude: 9.884683,
    },
    distributionStatus: DistributionStatus.NOT_STARTED,
    vessel: 'Biostar',
    vesselLocation: {
      latitude: 63.152365,
      longitude: 8.339815,
    },
    etaAtShipmentStart: '2024-07-26T15:16:08+00:00',
    currentEta: '2024-07-28T14:35:25+00:00',
    orderNumber: '1001244078',
    orderItems: [
      {
        itemName: 'HARMONY 1000 0.2PF NP750',
        quantity: 60000.0,
        lineNumber: 10,
        itemNumber: '000000000130040444',
      },
    ],
    distributionId: 'd7f31af3-a377-422d-afac-ef8c15d684f9',
    status: OrderShipmentStatus.LOADING,
    dispatchDate: '2024-07-26T00:00:00+00:00',
    plantName: 'Kristiansund',
    plantId: '2IRO',
    initialEta: dayjs().add(4, 'days').toISOString(),
    arrivalTime: '',
  },
  {
    siteName: 'NÆRINGSBUKTA',
    siteErpId: '2000069856',
    globalSiteId: 'ae68c309-56c1-4b77-a7ad-b8cd70f97107',
    siteLocation: {
      latitude: 70.658917,
      longitude: 22.642417,
    },
    distributionStatus: DistributionStatus.NOT_STARTED,
    vessel: 'With Frohavet',
    vesselLocation: {
      latitude: 70.76188666666667,
      longitude: 24.221655,
    },
    etaAtShipmentStart: '',
    currentEta: '2024-08-01T13:32:21+00:00',
    orderNumber: '1001279622',
    orderItems: [
      {
        itemName: 'ST102 1000 50A 500',
        quantity: 135000.0,
        lineNumber: 20,
        itemNumber: '000000000130090078',
      },
    ],
    distributionId: 'dea375de-8c20-4599-bb40-b125c5cc7618',
    status: OrderShipmentStatus.LOADING,
    dispatchDate: '2024-07-31T00:00:00+00:00',
    plantName: 'Bergneset',
    plantId: '1FBT',
    initialEta: dayjs().add(4, 'days').toISOString(),
    arrivalTime: '',
  },
  {
    siteName: 'FURNESET',
    siteErpId: '2800008248',
    globalSiteId: 'e79bbb46-7eea-4b3e-b864-867634a7b908',
    siteLocation: {
      latitude: 62.6461,
      longitude: 7.101183,
    },
    distributionStatus: DistributionStatus.FINISHED,
    vessel: 'Aqua Fjell',
    vesselLocation: {
      latitude: 64.85982666666666,
      longitude: 11.238265,
    },
    etaAtShipmentStart: '2024-07-24T19:33:02+00:00',
    currentEta: '2024-07-24T21:05:53+00:00',
    orderNumber: '1001222912',
    orderItems: [
      {
        itemName: 'ST102 1000 50A BLK',
        quantity: 100000.0,
        lineNumber: 30,
        itemNumber: '000000000130090079',
      },
      {
        itemName: 'RAPID MAX HP 200 40A 500',
        quantity: 20000.0,
        lineNumber: 50,
        itemNumber: '000000000107551872',
      },
    ],
    distributionId: 'e4c4160b-490e-4ae0-9c02-a389248ccb24',
    status: OrderShipmentStatus.DELIVERED,
    dispatchDate: '2024-07-23T00:00:00+00:00',
    plantName: 'Florø',
    plantId: '1FBS',
    initialEta: dayjs().add(4, 'days').toISOString(),
    arrivalTime: '2024-07-24T20:52:15+00:00',
  },
  {
    siteName: 'GJÆSINGEN',
    siteErpId: '2800007940',
    globalSiteId: '64a1792d-6e52-4d50-9779-e26591fa71df',
    siteLocation: {
      latitude: 64.117617,
      longitude: 9.981417,
    },
    distributionStatus: DistributionStatus.NOT_STARTED,
    vessel: 'Orion Olympus',
    vesselLocation: {
      latitude: 64.94696166666667,
      longitude: 11.457813333333332,
    },
    etaAtShipmentStart: '',
    currentEta: '2024-07-30T08:56:17+00:00',
    orderNumber: '1001257558',
    orderItems: [
      {
        itemName: 'ST102 1000 50A BLK',
        quantity: 80000.0,
        lineNumber: 10,
        itemNumber: '000000000130090079',
      },
    ],
    distributionId: 'eade6ee7-fee4-4dcb-b2bc-b83bfabdcd64',
    status: OrderShipmentStatus.LOADING,
    dispatchDate: '2024-07-28T00:00:00+00:00',
    plantName: 'Florø',
    plantId: '1FBS',
    initialEta: dayjs().add(4, 'days').toISOString(),
    arrivalTime: '',
  },
  {
    siteName: 'NORDNESBUKTA',
    siteErpId: '2800007589',
    globalSiteId: 'b6c30fba-b853-4816-b9cb-61aa8d274088',
    siteLocation: {
      latitude: 70.721533,
      longitude: 23.340933,
    },
    distributionStatus: DistributionStatus.NOT_STARTED,
    vessel: 'Rotsund',
    vesselLocation: {
      latitude: 70.63734500000001,
      longitude: 30.508294999999997,
    },
    etaAtShipmentStart: '',
    currentEta: '2024-07-29T02:52:32+00:00',
    orderNumber: '1001274250',
    orderItems: [
      {
        itemName: 'ST102 1000 50A 500',
        quantity: 80000.0,
        lineNumber: 20,
        itemNumber: '000000000130090078',
      },
    ],
    distributionId: 'f4e5b89e-3603-4c42-8aa4-0580f72e7ef5',
    status: OrderShipmentStatus.LOADING,
    dispatchDate: '2024-07-27T00:00:00+00:00',
    plantName: 'Bergneset',
    plantId: '1FBT',
    initialEta: dayjs().add(4, 'days').toISOString(),
    arrivalTime: '',
  },
  {
    siteName: 'REIRÅKLAKKEN',
    siteErpId: '2800008241',
    globalSiteId: 'b584164f-31e0-48cb-af00-e567d79343d7',
    siteLocation: {
      latitude: 63.44995,
      longitude: 8.167717,
    },
    distributionStatus: DistributionStatus.NOT_STARTED,
    vessel: 'Orion Olympus',
    vesselLocation: {
      latitude: 64.94696166666667,
      longitude: 11.457813333333332,
    },
    etaAtShipmentStart: '',
    currentEta: '2024-08-04T08:44:50+00:00',
    orderNumber: '1001270628',
    orderItems: [
      {
        itemName: 'RAPID MAX HP 500 50A 500',
        quantity: 50000.0,
        lineNumber: 20,
        itemNumber: '000000000107550941',
      },
      {
        itemName: 'RAPID MAX HP 200 40A BLK',
        quantity: 60000.0,
        lineNumber: 10,
        itemNumber: '000000000107553040',
      },
    ],
    distributionId: 'f9ae6dca-a65c-4034-b8ed-458b7d74c9d5',
    status: OrderShipmentStatus.LOADING,
    dispatchDate: '2024-08-01T00:00:00+00:00',
    plantName: 'Halsa',
    plantId: '1FBU',
    initialEta: dayjs().add(4, 'days').toISOString(),
    arrivalTime: '',
  },
  {
    siteName: 'MAKRELLSKJÆRET',
    siteErpId: '2800008590',
    globalSiteId: '5b0ecf23-dc02-46e8-b4f7-23fc48628192',
    siteLocation: {
      latitude: 64.549183,
      longitude: 10.734183,
    },
    distributionStatus: DistributionStatus.NOT_STARTED,
    vessel: 'Orion Olympus',
    vesselLocation: {
      latitude: 64.94696166666667,
      longitude: 11.457813333333332,
    },
    etaAtShipmentStart: '',
    currentEta: '2024-08-02T15:01:17+00:00',
    orderNumber: '1001255070',
    orderItems: [
      {
        itemName: 'RAPID 80 ADAPT 40A BLK',
        quantity: 120000.0,
        lineNumber: 20,
        itemNumber: '000000000107552893',
      },
    ],
    distributionId: 'fca36fa5-5d32-4b8b-a5d0-db7f06721c09',
    status: OrderShipmentStatus.LOADING,
    dispatchDate: '2024-08-01T00:00:00+00:00',
    plantName: 'Halsa',
    plantId: '1FBU',
    initialEta: dayjs().add(4, 'days').toISOString(),
    arrivalTime: '',
  },
];
